var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctorsCuate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.4,
    y: 46.81,
    width: 142.13,
    height: 308.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.57,
    y: 60.19,
    width: 117.79,
    height: 200.74,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.09 382.79 43.7 382.79 43.7 355.73 60.41 355.73 53.09 382.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.41 355.73 57.72 365.7 43.7 365.7 43.7 355.73 60.41 355.73",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.84 382.79 165.23 382.79 165.23 355.73 148.52 355.73 155.84 382.79",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.51 355.73 151.21 365.7 165.23 365.7 165.23 355.73 148.51 355.73",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.36,283.12c-8.82.18-17.65.28-26.47.35s-17.65.08-26.47.13l.48-.48c0,4.43,0,8.87,0,13.31l-.06,13.31c-.09,8.88-.18,17.75-.41,26.63-.23-8.88-.32-17.75-.41-26.63L110,296.43c0-4.44,0-8.88,0-13.31v-.49h.48c8.82.05,17.65,0,26.47.13S154.54,282.93,163.36,283.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.42,344c8.82-.19,17.65-.29,26.47-.36s17.65-.08,26.47-.13l-.48.49c0-4.36,0-8.71,0-13.06l.06-13.06c.09-8.71.19-17.41.41-26.12.22,8.71.32,17.41.41,26.12l.06,13.06c0,4.35,0,8.7,0,13.06v.48h-.48c-8.82-.05-17.65,0-26.47-.12S119.24,344.15,110.42,344Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.35,
    y: 304.92,
    width: 4.01,
    height: 15.36,
    transform: "translate(236.71 625.21) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.57,283.12c8.82-.19,17.65-.29,26.47-.36s17.65-.08,26.47-.13H99v.49c0,4.43,0,8.87,0,13.31l-.06,13.31c-.09,8.88-.18,17.75-.41,26.63-.23-8.88-.32-17.75-.41-26.63L98,296.43c0-4.44,0-8.88,0-13.31l.48.48c-8.82-.05-17.65,0-26.47-.13S54.39,283.3,45.57,283.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.51,344c-8.82.18-17.65.28-26.47.36s-17.65.07-26.47.12h-.48V344c0-4.36,0-8.71,0-13.06l.06-13.06c.1-8.71.19-17.41.41-26.12.22,8.71.32,17.41.41,26.12L46,330.91c0,4.35.05,8.7,0,13.06l-.49-.49c8.82,0,17.65,0,26.47.13S89.69,343.78,98.51,344Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.57,
    y: 304.92,
    width: 4.01,
    height: 15.36,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.57,
    y: 114.72,
    width: 117.79,
    height: 1.83,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.57,
    y: 161.78,
    width: 117.79,
    height: 1.83,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.57,
    y: 208.84,
    width: 117.79,
    height: 1.83,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.11,
    y: 60.19,
    width: 2.71,
    height: 200.74,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.44,
    y: 138.55,
    width: 13.96,
    height: 23.23,
    transform: "translate(230.84 300.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.53,
    y: 134.6,
    width: 17.78,
    height: 3.95,
    transform: "translate(230.84 273.15) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.23,
    y: 143.66,
    width: 10.37,
    height: 14.33,
    transform: "translate(230.84 301.65) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.25,
    y: 138.55,
    width: 13.96,
    height: 23.23,
    transform: "translate(268.46 300.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.34,
    y: 134.6,
    width: 17.78,
    height: 3.95,
    transform: "translate(268.46 273.15) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.04,
    y: 143.66,
    width: 10.37,
    height: 14.33,
    transform: "translate(268.46 301.65) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.06,
    y: 138.55,
    width: 13.96,
    height: 23.23,
    transform: "translate(306.08 300.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.15,
    y: 134.6,
    width: 17.78,
    height: 3.95,
    transform: "translate(306.08 273.15) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.85,
    y: 143.66,
    width: 10.37,
    height: 14.33,
    transform: "translate(306.08 301.65) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,183.76H66.5a0,0,0,0,1,0,0v19.77a5.31,5.31,0,0,1-5.31,5.31H53.31A5.31,5.31,0,0,1,48,203.54V183.76A0,0,0,0,1,48,183.76Z",
    transform: "translate(114.51 392.61) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.89,
    y: 181.28,
    width: 10.72,
    height: 2.56,
    transform: "translate(114.51 365.12) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.16,
    y: 178.55,
    width: 16.18,
    height: 2.73,
    transform: "translate(114.51 359.83) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.97,
    y: 189.84,
    width: 15.53,
    height: 13.54,
    transform: "translate(117.47 393.22) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,183.76h18.5a0,0,0,0,1,0,0v19.77a5.31,5.31,0,0,1-5.31,5.31H74a5.31,5.31,0,0,1-5.31-5.31V183.76A0,0,0,0,1,68.68,183.76Z",
    transform: "translate(155.86 392.61) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.57,
    y: 181.28,
    width: 10.72,
    height: 2.56,
    transform: "translate(155.86 365.12) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.84,
    y: 178.55,
    width: 16.18,
    height: 2.73,
    transform: "translate(155.86 359.83) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.65,
    y: 189.84,
    width: 15.53,
    height: 13.54,
    transform: "translate(158.83 393.22) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.64,
    y: 230.95,
    width: 23.18,
    height: 29.99,
    transform: "translate(238.46 491.89) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.64 230.95 130.82 230.95 126.37 224.84 112.08 224.84 107.64 230.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.44,
    y: 218.89,
    width: 19.58,
    height: 5.95,
    transform: "translate(238.46 443.72) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 237.62,
    width: 19.87,
    height: 13.48,
    transform: "translate(241.76 488.72) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.56,
    y: 230.95,
    width: 23.18,
    height: 29.99,
    transform: "translate(288.3 491.89) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.56 230.95 155.74 230.95 151.29 224.84 137 224.84 132.56 230.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.36,
    y: 218.89,
    width: 19.58,
    height: 5.95,
    transform: "translate(288.3 443.72) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.87,
    y: 237.62,
    width: 19.87,
    height: 13.48,
    transform: "translate(291.6 488.72) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,114.72H53.49a4.33,4.33,0,0,1-4.33-4.33h0a4.33,4.33,0,0,1,4.33-4.32H95a4.33,4.33,0,0,1,4.33,4.32h0A4.33,4.33,0,0,1,95,114.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,105.5H53.49a4.32,4.32,0,0,1-4.33-4.32h0a4.33,4.33,0,0,1,4.33-4.33H95a4.33,4.33,0,0,1,4.33,4.33h0A4.32,4.32,0,0,1,95,105.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.31,96.29H54.21a3.1,3.1,0,0,1-3.11-3.1h0a3.11,3.11,0,0,1,3.11-3.11h40.1a3.11,3.11,0,0,1,3.11,3.11h0A3.1,3.1,0,0,1,94.31,96.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.31,89.53H54.21a3.11,3.11,0,0,1-3.11-3.11h0a3.1,3.1,0,0,1,3.11-3.1h40.1a3.1,3.1,0,0,1,3.11,3.1h0A3.11,3.11,0,0,1,94.31,89.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.83,
    cy: 77.06,
    r: 30.25,
    transform: "translate(217.39 451.1) rotate(-72.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.21,
    cy: 77.73,
    r: 28.86,
    transform: "translate(20.71 229.17) rotate(-31.39)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.21,
    cy: 77.73,
    r: 27.04,
    transform: "translate(20.77 229.32) rotate(-31.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.64,72c-12.31,7.46-32.55,19.7-43.86,26.41a27.08,27.08,0,0,1-7.39-9.94L430.8,53.79A27.07,27.07,0,0,1,444.64,72Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.23,78.67a26.72,26.72,0,0,1-1.78,8.79l-33.73,16a26.8,26.8,0,0,1-4.26-1.83C415.65,95.69,434.27,85,445.23,78.67Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.95,
    y: 52.65,
    width: 0.52,
    height: 4.1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.44,
    y: 55.74,
    width: 0.52,
    height: 4.1,
    transform: "translate(25.59 211.08) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.01,
    y: 64.17,
    width: 0.52,
    height: 4.1,
    transform: "translate(141.76 378) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.14,
    y: 77.47,
    width: 4.1,
    height: 0.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.22,
    y: 88.98,
    width: 4.1,
    height: 0.52,
    transform: "translate(8.75 211.12) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.65,
    y: 97.41,
    width: 4.1,
    height: 0.52,
    transform: "translate(118.91 401.19) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.95,
    y: 98.71,
    width: 0.52,
    height: 4.1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.47,
    y: 95.62,
    width: 0.52,
    height: 4.1,
    transform: "translate(8.74 227.95) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.9,
    y: 87.19,
    width: 0.52,
    height: 4.1,
    transform: "translate(141.77 424.06) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.19,
    y: 77.47,
    width: 4.1,
    height: 0.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.11,
    y: 65.96,
    width: 4.1,
    height: 0.52,
    transform: "translate(25.62 228.02) rotate(-30.01)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.68,
    y: 57.53,
    width: 4.1,
    height: 0.52,
    transform: "translate(165.02 401.2) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.61 54.51 419.5 79.56 416.93 79.52 417.91 54.5 418.61 54.51",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.21 69 417.36 79.75 416.13 77.5 433.88 68.38 434.21 69",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.09,77.73a.88.88,0,1,1-.88-.88A.88.88,0,0,1,419.09,77.73Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-79"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 452.34,
    rx: 211.97,
    ry: 22.61,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-79"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "33.4 382.79 87.55 382.55 141.7 382.46 250 382.3 358.3 382.46 412.45 382.55 466.6 382.79 412.45 383.04 358.3 383.13 250 383.29 141.7 383.13 87.55 383.04 33.4 382.79",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Heart--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.65,72a77.2,77.2,0,0,1-24.77,21.5A77.2,77.2,0,0,1,256.11,72c-8.72-11.54-8.29-29.61,4.19-33.51C274.1,34.19,280.88,55,280.88,55s6.88-20.9,20.59-16.44C313.9,42.56,314.37,60.49,305.65,72Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.15 84.41 267.38 68.75 264.93 74.27 249.74 74.27 249.74 72.5 263.78 72.5 267.89 63.27 270.82 75.48 274.96 50.18 278.62 70.2 281.52 61.84 286.08 75.52 287.09 72.5 312.04 72.5 312.04 74.26 288.36 74.26 286.08 81.1 281.49 67.33 278.1 77.13 275.06 60.53 271.15 84.41",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.66,323.93s15.9-3.6,24.61-11.63,13.58-22.4,13.58-22.4A136.21,136.21,0,0,0,449,294.58a30.13,30.13,0,0,0-5.39,7.62,36.06,36.06,0,0,1,0-5.45,24.21,24.21,0,0,0-5.66,3.44C430.7,306.51,428.66,323.93,428.66,323.93Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.92,296.89c2.17-1.5,4.37-2.95,6.53-4.46.13-.09,0-.3-.13-.21-4.1,2.44-8.13,5.06-12,7.79q-2,1.44-4,3c.09-.16.18-.32.28-.48.47-.79,1-1.58,1.48-2.36a33.61,33.61,0,0,1,3.37-4.5c.05-.05,0-.13-.08-.08-1.23,1.43-2.47,2.84-3.6,4.36-.54.72-1,1.46-1.51,2.22-.25.4-.48.8-.71,1.2l-.24.41c-2.06,1.62-4.06,3.3-6,5.08-1.18,1.1-2.31,2.24-3.41,3.41.61-1.92,1.15-3.87,1.86-5.76,0-.07-.08-.09-.1,0-.69,2-1.45,4-2,6-1.21,1.31-2.38,2.67-3.47,4.09,0-.08,0-.17.05-.26.18-.75.37-1.49.57-2.24.39-1.44.81-2.86,1.29-4.27a25,25,0,0,1,4.27-8.07c0-.05,0-.12-.07-.07a30.87,30.87,0,0,0-6.09,12.71c-.17.68-.33,1.36-.49,2-.08.36-.17.73-.23,1.1-.48.64-1,1.3-1.41,2a68.83,68.83,0,0,0-6.72,13.19,154.45,154.45,0,0,0-5.1,15.88.09.09,0,0,0,.17,0c3.1-9.3,6.28-18.73,11.6-27a62.33,62.33,0,0,1,3.63-5.07,30.47,30.47,0,0,0,7.73-1.54,34.84,34.84,0,0,0,7.75-3.74c1.39-.91,2.67-2,4-3a.06.06,0,1,0-.07-.09,31.85,31.85,0,0,1-7.29,4.41,39.6,39.6,0,0,1-8,2.69c-1.17.26-2.36.45-3.55.61a69.86,69.86,0,0,1,4.69-5.2c.53-.53,1.09-1,1.64-1.56a38.06,38.06,0,0,1,5.88-3.37c2.6-1.25,5.16-2.59,7.74-3.9,1.46-.74,2.9-1.5,4.37-2.21.06,0,0-.12-.06-.09-2.61,1.26-5.27,2.44-7.9,3.65-2.48,1.13-5,2.27-7.38,3.61l-.3.18q3.24-2.81,6.66-5.38C452.61,300,454.75,298.39,456.92,296.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,305.08c-1.3.57-2.61,1.07-3.89,1.67a42.47,42.47,0,0,0-3.81,2.07c-.06,0,0,.11.05.08,1.27-.6,2.55-1.17,3.8-1.8s2.56-1.34,3.88-1.92C456.11,305.16,456.08,305.05,456,305.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,243.84a22.73,22.73,0,0,1,4.75,13.2c.05,1.42-.17,3.41-.34,5.74a37.82,37.82,0,0,1,10.38,8.87,18.84,18.84,0,0,0-10.49-2.51,32.19,32.19,0,0,0,.61,4.75,17.83,17.83,0,0,1,6.74,1.33,15,15,0,0,0-6.08,1.21c2.84,9,11.26,18.27,34.51,22.21A48.78,48.78,0,0,0,413,265.91C406,252.2,377,243.84,377,243.84Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.16,337.2c-.4-3.85-.91-7.69-1.5-11.51A232.11,232.11,0,0,0,419,302.92a92.23,92.23,0,0,0-3.36-10.37,16.55,16.55,0,0,0,.09-1.86c0-.75,0-1.49,0-2.24,0-1.49-.09-3-.22-4.46a53.74,53.74,0,0,0-1.42-8.72c-.43-1.65-.92-3.28-1.41-4.92a.05.05,0,1,0-.1,0,64,64,0,0,1,1.71,8.7,79.73,79.73,0,0,1,.78,8.73c0,.8.05,1.6.05,2.4,0,.34,0,.68,0,1a73.69,73.69,0,0,0-3.92-8.11,97.5,97.5,0,0,0-8-11.9,4.7,4.7,0,0,0-.19-1.3l-.33-1.56c-.24-1.06-.51-2.12-.8-3.17-.58-2.11-1.34-4.14-2-6.22a.05.05,0,1,0-.1,0c.61,2.06,1,4.19,1.49,6.29.24,1,.46,2.07.69,3.11.11.52.23,1,.33,1.56a.5.5,0,0,1,0,.12c-.94-1.19-1.89-2.36-2.88-3.51-4.44-5.21-9.31-10-14.21-14.78-.6-.59-1.22-1.16-1.83-1.74-.05-.05-.12,0-.07.08C388,255,392.6,260,397,265.13q1.56,1.85,3.06,3.73l-1.58-1.05c-1.36-.88-2.73-1.74-4.14-2.53s-2.83-1.57-4.28-2.29-3.09-1.34-4.52-2.17c-.07,0-.12.06-.06.09a34.49,34.49,0,0,1,4.25,2.35c1.41.84,2.83,1.69,4.22,2.57s2.74,1.72,4.09,2.6c1.13.74,2.25,1.54,3.42,2.22a110.09,110.09,0,0,1,7.45,10.84,78.31,78.31,0,0,1,3.85,7.3l-.83-.36-2.13-.94c-1.37-.61-2.74-1.2-4.12-1.8-2.6-1.13-5.25-2.18-7.81-3.42a34.62,34.62,0,0,1-4.17-2.32c-.06,0-.11.06-.06.1,4.77,3.28,10.12,5.6,15.39,7.93l2.29,1c.63.28,1.26.59,1.91.83a82.54,82.54,0,0,1,3.93,10.78,218.77,218.77,0,0,1,5.06,22.49c1.33,7.6,2.23,15.24,2.93,22.92.09,1,.18,1.92.29,2.87a.3.3,0,0,0,.6,0C426,345,425.57,341.08,425.16,337.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,273c-.42-2.36-1.05-4.67-1.69-7,0-.06-.12,0-.1,0,.59,2.28,1,4.59,1.43,6.9s.82,4.71,1.16,7.08c0,0,.06,0,.06,0A61.26,61.26,0,0,0,411,273Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,279.39a41.63,41.63,0,0,0-5.05-2.84c-.85-.44-1.71-.86-2.57-1.27s-1.8-.79-2.68-1.23a.06.06,0,0,0-.05.1c.85.42,1.65.94,2.49,1.39l2.58,1.42c1.7.91,3.37,1.92,5.16,2.66A.13.13,0,0,0,401,279.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,296.4s14.71-3.51,21.46-13.38c6.45-9.42,8.53-25.48,8.7-26.89-.27,1.29-3.3,15.33-13.31,21.87C438.13,283,430.72,287.13,429,296.4Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.53,271a18.82,18.82,0,0,0-5.43,8.93s0,.05,0,0a21.87,21.87,0,0,1,5.45-8.87C442.65,271,442.58,270.94,442.53,271Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,296.4s14.71-3.51,21.46-13.38c6.45-9.42,8.53-25.48,8.7-26.89a.65.65,0,0,1,0-.1s-7.06,10-14.47,12.58S426.83,280,429,296.4Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.52,261.56a58.66,58.66,0,0,1-4.55,7.77,31.06,31.06,0,0,1-6.05,6.23c-2,1.58-4.11,3-6.13,4.58l0-.08c.38-.56.78-1.11,1.2-1.64.84-1.08,1.76-2.09,2.69-3.1,1.83-2,3.69-3.93,5.33-6.07a22.29,22.29,0,0,0,2.36-3.8c0-.06-.07-.1-.1,0-2.39,5-7.15,8.15-10.55,12.35a22.1,22.1,0,0,0-1.36,1.86,7.36,7.36,0,0,0-.85,1.5,30,30,0,0,0-5,5.07,19.6,19.6,0,0,1,.59-2.86,14.43,14.43,0,0,1,1.55-3.72.05.05,0,1,0-.09-.06,18,18,0,0,0-1.71,3.7,12.84,12.84,0,0,0-.54,3.18h0a27.87,27.87,0,0,0-2,3.08l.18-.94c.29-1.46.62-2.92,1-4.37a26.35,26.35,0,0,1,3.53-8.29c0-.05-.05-.11-.09-.05a31.6,31.6,0,0,0-3.92,8.1c-.46,1.44-.84,2.91-1.17,4.39-.16.73-.31,1.45-.45,2.18-.07.38-.15.76-.21,1.15a52.79,52.79,0,0,0-3.39,10,146,146,0,0,0-3.14,18.59,155.17,155.17,0,0,0-1,19.75c0,.83.06,1.65.11,2.48,0,.21.33.24.34,0,.14-3.26.23-6.53.42-9.79s.48-6.52.83-9.77a172.32,172.32,0,0,1,3.06-19c1.19-5.37,2.74-10.79,5.68-15.5a29.13,29.13,0,0,1,5.3-6.31c2.07-1.85,4.32-3.47,6.49-5.18a35.15,35.15,0,0,0,6-5.73,46.5,46.5,0,0,0,4.68-7.59c.34-.67.7-1.33,1.05-2C456.64,261.56,456.55,261.5,456.52,261.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,263.71a49.83,49.83,0,0,1-3.27,5.73c0,.05,0,.09.06.05a39.93,39.93,0,0,0,3.31-5.74C454.11,263.69,454,263.65,454,263.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,289.9s-.23,20.9,12.27,26.93,19.19,1,27.68,3h0c-.33-.5-6.39-9.21-16-11.61C389,305.77,378,298.61,375,289.9Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,289.9s-.23,20.9,12.27,26.93,19.19,1,27.68,3h0a47.34,47.34,0,0,0-14.21-4.19C392.83,314.71,377.78,309.57,375,289.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.76,320.23a20.9,20.9,0,0,0-5-3.36c-.27-.13-.55-.24-.82-.35a4.81,4.81,0,0,0-.42-.48,15.61,15.61,0,0,0-1.18-1.12,17.2,17.2,0,0,0-2.51-1.81c-2.07-1.22-4.34-2.07-6.46-3.2-.06,0-.11.06,0,.09,1,.54,2.06,1.14,3.08,1.74s2,1.13,3,1.75a23.37,23.37,0,0,1,2.47,1.85c.22.2.43.41.64.62a32.38,32.38,0,0,0-4.22-1.12c-2.29-.47-4.6-.79-6.89-1.28a31.08,31.08,0,0,1-3.31-.9c-1-.83-2.07-1.66-3.06-2.57a25.55,25.55,0,0,1-3.23-3.58c0-.05-.13,0-.09.06a38.1,38.1,0,0,0,5.12,5.65c-.53-.2-1.07-.42-1.59-.66a25.72,25.72,0,0,1-10.65-8.86.05.05,0,1,0-.09.06,29.26,29.26,0,0,0,8.61,8.27,26.27,26.27,0,0,0,5.44,2.57,49.31,49.31,0,0,0,6.77,1.6,48.3,48.3,0,0,1,6.62,1.58,20.06,20.06,0,0,1,5.55,2.92A25.93,25.93,0,0,1,421,329a46.47,46.47,0,0,1,4.13,15.28c0,.22.37.22.35,0C424.88,335.47,422.53,326.33,415.76,320.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.25,313.42a7.11,7.11,0,0,0-2.57-2.33,9.44,9.44,0,0,1-3.05-2.53.05.05,0,1,0-.09.06,10.19,10.19,0,0,0,2.7,2.41,9.61,9.61,0,0,1,2.94,2.43C401.21,313.51,401.29,313.47,401.25,313.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.88 335.66 408.45 347.15 410.2 382.26 436.41 382.26 438.15 347.15 438.72 335.66 407.88 335.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.88 335.66 408.45 347.15 438.15 347.15 438.72 335.66 407.88 335.66",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.05,
    y: 330.86,
    width: 34.51,
    height: 10.96,
    transform: "translate(846.61 672.68) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.66,440.74c-2.33.77-68.86.58-71.4-1-.95-.6-1.49-10.3-1.81-22-.07-2.53-.16-43.36-.16-43.36H398.6l-.26,43.36s25.44,11.48,28,13.54S431,440,428.66,440.74Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.61,422.82c.33,9.31.84,16.38,1.66,16.9,2.52,1.6,69.05,1.79,71.39,1s.28-7.46-2.29-9.51c-1.43-1.14-9.76-5.12-17-8.47,2.52,1.56,5.73,3.78,5.44,5.1C414.29,430.44,381.16,432.12,355.61,422.82Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.61,422.82c.33,9.31.84,16.38,1.66,16.9,2.52,1.6,69.05,1.79,71.39,1s.28-7.46-2.29-9.51c-1.43-1.14-9.76-5.12-17-8.47,2.52,1.56,5.73,3.78,5.44,5.1C414.29,430.44,381.16,432.12,355.61,422.82Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.38,189.76s11.71,115.77,12,117.23c0,.2.12,2.43.23,6.06C352.23,333,353,401,353,401H400.7s-2.27-79.44-4.06-96.61c-2.28-21.91-16.74-114.59-16.74-114.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.06,311.07q-2.21-37.62-6.64-75.07c-1.68-14.07-3.7-28.08-5.7-42.11,0-.12-.21-.11-.2,0,3.7,24.95,6.32,50.11,8.57,75.23.8,8.88,2.31,24.17,3.11,42,1.47,32.55,2.09,71.48,2.39,80.7a.27.27,0,0,0,.53,0C358.44,366.37,358.55,336.47,357.06,311.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.42,393c-21.76-.68-40.6-.2-42.22-.07-1.35.1-.6.25.07.29,18.48,1.1,41.43.06,42.16,0A.1.1,0,1,0,397.42,393Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.38,189.76s11.71,115.77,12,117.23c0,.2.12,2.43.23,6.06l22.51-123.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.19,446.51c-2.41.42-69.47-9.91-71.74-11.87-.86-.74,11.06-64.23,11.06-64.23l43.76,6.46-8,43.45s21.85,14,24.1,16.43S355.6,446.09,353.19,446.51Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.45,434.63c2.27,2,69.33,12.3,71.75,11.88s1.37-7.35-.88-9.76c-1.31-1.4-9.16-6.67-15.55-10.88,2.27,2,5.46,5,4.93,6.3-1,2.46-34.05-1.45-57.69-14.94C282.33,427,281.16,434.39,281.45,434.63Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.45,434.63c2.27,2,69.33,12.3,71.75,11.88s1.37-7.35-.88-9.76c-1.31-1.4-9.16-6.67-15.55-10.88,2.27,2,5.46,5,4.93,6.3-1,2.46-34.05-1.45-57.69-14.94C282.33,427,281.16,434.39,281.45,434.63Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.9,189.76s-1.42,11.78-8.18,20.28c-1.62,2-6.59,3.93-9.16,5.81,0,0-9.61,88.26-12.53,98.27-3.25,11.1-15.94,87-15.94,87l-49.22-6.79s14.32-71.25,17.87-89.71c.8-4.12,11.48-81.81,11.24-83.61-2.87-21.39,7.54-31.29,7.54-31.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.29,190.6a21.12,21.12,0,0,1-5.94,10.57,19.27,19.27,0,0,1-10.81,5.46c-.64.07-.56.51.12.5,7.79,0,15.72-6.35,16.95-16.47A.16.16,0,1,0,342.29,190.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.65,209.69a42.51,42.51,0,0,0-8,4.27c-2.67,1.65-5.14,3.59-7.72,5.38-.1.06,0,.23.09.16,2.71-1.56,5.53-2.91,8.2-4.51a51.84,51.84,0,0,0,7.59-5.09C372.85,209.82,372.76,209.65,372.65,209.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.74,193.45c-.42,1.79-.93,3.55-1.4,5.32s-.79,3.36-1.31,5a8.53,8.53,0,0,1-2.54,4.12c-.69.58-1.44,1.09-2.17,1.62-.39.28-.81.56-1.22.84.06-.23.12-.47.17-.71.15-.68.3-1.36.44-2,.33-1.5.64-3,.94-4.51.59-3,1.15-6,1.91-8.89a.1.1,0,0,0-.19-.06c-.87,2.9-1.83,5.76-2.61,8.68-.38,1.44-1.84,8.53-1.91,9s-.15,1-.19,1.56a6.72,6.72,0,0,0-.08,1.61.14.14,0,0,0,.25,0h0a6,6,0,0,0,.53-1.54c.15-.5.29-1,.41-1.53,0-.18.08-.37.11-.56.72-.4,1.41-.94,2.09-1.38s1.48-.95,2.17-1.49a8,8,0,0,0,2.75-3.89,28.57,28.57,0,0,0,1.08-5.1c.32-2,.58-4.06,1-6.07C374,193.39,373.77,193.33,373.74,193.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,391.45c-21.45-3.71-40.17-5.86-41.8-6-1.35-.08-.63.16,0,.3,18.15,3.66,41,5.83,41.75,5.85A.1.1,0,0,0,331.8,391.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.72,342.7c2.82-12.35,5.37-24.73,7.46-37.22s3.77-24.93,5.37-37.43,3.23-25.22,4.85-37.83c.39-3.06,1-6.21.89-9.31s-1.18-5.93-1.47-8.94a40.35,40.35,0,0,1,2.47-17.23c.49-1.4,1-2.77,1.64-4.13.08-.17.36-.1.29.1-1.88,5.7-3.63,11.56-3.72,17.62a41.4,41.4,0,0,0,1.18,9.14,26.41,26.41,0,0,1,.16,8.87Q316.49,245.16,314,264c-1.6,12.5-3.24,25-5.22,37.45s-4.31,24.74-7.12,37-5.71,24.69-8.8,37c-.38,1.53-.76,3.05-1.17,4.58,0,.17-.3.09-.27-.09C293.94,367.45,296.89,355.08,299.72,342.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.92,82.59c-3.75-4.55-10.13-5.66-16.32-4.38S338,82.71,337.35,93.43c-.54,8.71,2.09,17.21,2.07,26.92s-10.54,33.36,6.46,45c15.27,10.41,46.16,1,47.06-20.4.71-16.93-18.69-32.62-20.74-39.33S372,87.57,367.92,82.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.72,92.15a38.76,38.76,0,0,0,2.77,14.32,13.83,13.83,0,0,0,1.93,3.22c.75,1,1.55,1.9,2.34,2.82,1.61,1.82,3.21,3.62,4.71,5.5A50.18,50.18,0,0,1,390,130.2a39.65,39.65,0,0,1,3,14,34.21,34.21,0,0,0-.23-7.29,36.66,36.66,0,0,0-1.82-7.12,44.87,44.87,0,0,0-7.39-12.65c-1.54-1.9-3.18-3.72-4.8-5.51a24.94,24.94,0,0,1-4.28-5.64,32,32,0,0,1-2.36-6.75A63,63,0,0,1,370.72,92.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.81,100.75c.12,4.94.43,9.88.32,14.78a63.2,63.2,0,0,1-.58,7.3c-.34,2.38-1,4.76-1.59,7.17s-1.08,4.85-1.45,7.31a43.51,43.51,0,0,0-.45,7.48,27.32,27.32,0,0,0,1.36,7.39,18.6,18.6,0,0,0,4,6.26A19.92,19.92,0,0,1,336,152a26.91,26.91,0,0,1-.94-7.2,64.82,64.82,0,0,1,2.16-14.46c.54-2.4,1.22-4.78,1.55-7.31a50.44,50.44,0,0,0,.35-7.47A125.65,125.65,0,0,0,337.81,100.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.94,142.2c4.55,11.32,22.65,47.87,34.54,50.45,7.8,1.69,39.33-1.36,44.75-8.82,2.37-3.25-1.63-25.91-5.83-25s-29.48,4.24-32.58,3.34-26.37-27.69-35.06-34.34C349.77,116.35,356.49,136.11,358.94,142.2Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.86,157.19l.67,34s-25,4.56-35.67.43c-13-5-30.72-46.38-33.12-53.16-3.92-11.13-2.49-17.73,3.58-15.89,2.36.7,5.42,2.69,9.13,6.2,3.89,3.66,26.11,27.33,33.22,31.9C404.65,163.27,422.86,157.19,422.86,157.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.2,189.79c-.25-5-.52-25.64-.28-30.1,0-.3.22-.37.24-.05,1.12,15.05.25,25.19.24,30.14A.1.1,0,0,1,417.2,189.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,192.69c-8.13.85-19,1.34-25.09-1-13-5-30.72-46.37-33.11-53.16-3.93-11.13-2.5-17.73,3.57-15.89.19.06.38.12.57.2Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.92,170.82l4.75,32.69s-53.26.78-66.48-.15c0,0,10.79-61.1,25-76.53,7.11-7.72,15.46-7.15,20.78-1.75,1.35,1.37,17.41,22.6,19.11,30.71C382.55,163,377.92,170.82,377.92,170.82Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.09,122.3s4.62,175.51.22,183.05c-2.69,4.6-47.06-6.42-47.06-6.42s11.47-104,24.65-141C337.12,123.62,347.09,122.3,347.09,122.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.69,237.83c-.23,7.28.11,15.52,1.66,17,2.9,2.84,10.63,2.6,13,2.58s11.08,0,13.11-4.49c.9-2,1.14-12.13,1.11-15.73,0-1.46-.34-8.65-.44-9.46,0-.19-.55-.16-.56,0-.13.82-.05,3.81-.09,4.38-13.93,1.79-22.56.29-27-.57,0-1.35,0-2.39,0-3.74a75.81,75.81,0,0,0,13.2,1.25c4.83,0,12.1-.72,14.47-1,.11,0,0-.55-.14-.55-1.81,0-8.11.64-14.45.64A114.73,114.73,0,0,1,314,227.05C313.8,227.12,313.8,234.34,313.69,237.83Zm2.5,16.2c-1.54-1.76-1.72-6.85-1.72-9.89,0-4.19,0-7.53,0-11.72,10.72,2.49,22.53,1.26,27,.36,0,.18.08,9,0,11.83-.11,3.6-.22,6.85-1.6,8.72-1.19,1.6-4.53,3.21-12.2,3.2C322.16,256.52,317.48,255.51,316.19,254Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.89,302.07c1.82,2.2,16.45-5,16.45-5L378.21,170.23a21.24,21.24,0,0,0,2.88-14.3c-1.38-8-18.08-31.1-20.78-32.3a256.93,256.93,0,0,1,5.79,36.26C370.74,209.86,379.31,298.93,381.89,302.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.83,145.13c-1.48-2.37-3-4.71-4.47-7.1,0-.07.06-.15.11-.08,1.49,2,2.94,3.94,4.38,5.93-.47-1.07-.94-2.14-1.37-3.23-.05-.12.13-.23.19-.1.66,1.4,1.26,2.82,1.84,4.25a41,41,0,0,1,3.41,5.63,19.6,19.6,0,0,1,1.8,13.29,16.38,16.38,0,0,1-1.33,3.64c-.39.79-1.67,2.49-1.66,2.54.83,4.66,1.46,9.37,2.11,14.06s1.34,9.49,1.89,14.24c.32,2.7.52,5.41.91,8.09,0,.1-.14.14-.15,0-.34-2.33-.85-4.65-1.26-7s-.81-4.66-1.19-7c-.76-4.72-1.43-9.46-2.11-14.19-.39-2.68-.81-5.35-1.12-8a27.85,27.85,0,0,1,1.53-2.94,18.67,18.67,0,0,0,1.17-3.07,17.22,17.22,0,0,0,.57-6.62C380.56,153,378.21,148.93,375.83,145.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.44,124.15q2.35,3.57,4.78,7.07c1.63,2.33,3.23,4.69,4.89,7l0-.56-4,4.19-.33.34.35.34c1.68,1.63,3.39,3.23,5.09,4.83l-.14-.42c-.62,4.34-1.28,8.66-1.83,13s-1.13,8.68-1.61,13q1.23-6.45,2.3-12.93c.75-4.31,1.4-8.64,2.08-13l0-.24-.18-.17c-1.69-1.62-3.37-3.25-5.08-4.84l0,.68,3.92-4.25L371,138l-.21-.28c-1.68-2.3-3.42-4.55-5.13-6.82S362.21,126.38,360.44,124.15Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.64,132.79c-21,19.66-45.62,53.74-36.92,62.09,5.78,5.54,34.74-31.49,34.23-31.4-1.08.2,5.2-12.1,12.9-27C351.44,119.83,344.62,121.56,332.64,132.79Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.86,124.22c-14.59,7.23-54.74,54-49.49,68.43s38.4-29,38.06-29.59,8.07-17.09,11.5-23.78S350.63,120.36,342.86,124.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.87,147.09c-.8.85-1.59,1.71-2.35,2.6l-.41.51.69-1.42a49.76,49.76,0,0,0,2.33-5c0-.08-.08-.12-.13-.06a54.29,54.29,0,0,0-2.83,5.05c-.89,1.65-1.8,3.31-2.66,5s-1.74,3.34-2.57,5a38.28,38.28,0,0,0-2.27,5.07.1.1,0,0,0,.17.08,40.25,40.25,0,0,0,2.9-5c.88-1.66,1.72-3.35,2.57-5,.36-.7.71-1.41,1.05-2.12l.41-.46c.38-.42.73-.87,1.08-1.32.72-.92,1.4-1.87,2.08-2.83C341,147.1,340.9,147.06,340.87,147.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,124.31c-1.1,2.55-2.21,5.09-3.36,7.62s-2.27,5-3.46,7.55l-.11-.54,4.22,3.62.35.3-.27.38c-1.3,1.83-2.63,3.64-3.95,5.44l.07-.43c1.17,4.21,2.39,8.41,3.5,12.64s2.26,8.45,3.31,12.69q-2-6.22-3.92-12.5c-1.3-4.17-2.49-8.37-3.73-12.56l-.07-.24.14-.19c1.31-1.83,2.61-3.66,3.94-5.46l.08.68-4.16-3.7-.26-.23.15-.31c1.2-2.49,2.47-4.94,3.71-7.41S345.71,126.74,347,124.31Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.85,128.34c-.35-5.24,3.93-7.1,7.85-7.63,4.64-.63,7.74-.24,10,4.27,2.35,4.75,3.57,10.27,4.49,15.47a.77.77,0,0,0,1.51-.25c-1.06-6-2.57-17.16-8.53-20.43-5.48-3-17.38-.06-16.79,8.81.06,1,1.58.74,1.51-.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.84,142.63a3.52,3.52,0,1,1-4-2.92A3.52,3.52,0,0,1,371.84,142.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.45,142.85a2.12,2.12,0,1,1-2.42-1.76A2.12,2.12,0,0,1,370.45,142.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.14,144.75c3.85,14.71,3.25,18.3,2,20a9.73,9.73,0,0,1-3.46,2.78l-.44-1,.22.49-.22-.49a8.94,8.94,0,0,0,3-2.43c.88-1.23,1.62-4.53-2.19-19.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.17,
    y: 165.27,
    width: 2.28,
    height: 3.7,
    rx: 1.11,
    transform: "translate(370.12 552.82) rotate(-118.87)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.54,145.1c-2.94,11.08-3.65,17.14-2.25,19.09a8.8,8.8,0,0,0,3,2.44l-.45,1a9.82,9.82,0,0,1-3.45-2.79c-1.67-2.32-1.06-8.11,2.09-20Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.25,165.35h0a1.11,1.11,0,0,1,1.11,1.11v1.47a1.12,1.12,0,0,1-1.12,1.12h0a1.11,1.11,0,0,1-1.11-1.11v-1.47a1.11,1.11,0,0,1,1.11-1.11Z",
    transform: "translate(29.33 384.26) rotate(-60.93)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.14,144.36a62.61,62.61,0,0,1,1.92-7.25,6.51,6.51,0,0,1,2.15-2.62c.21,0,.12-1.88,0-3.41-.09-1.34-.23-2.91.09-3.34a1.06,1.06,0,0,1,1.47-.08c.37.4.38,2,.43,3.32.05,1.53.15,3.4.36,3.4a7,7,0,0,1,2.28,2.42,51.32,51.32,0,0,1,2.53,7.24c.34,1.58-.18,1.77-.63,1.93-.64.21-1-.22-1.54-2-.79-2.76-1.79-7.42-3.71-7.4h0c-1.91.19-2.69,5.12-3.31,7.86-.39,1.72-.75,1.89-1.41,1.74C339.31,146.08,338.84,145.88,339.14,144.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.31,146.18s-3.7-5.55.28-7.76,6.75,3.85,6.75,3.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,183h0l.17,6.52.06,2.15-1.81-1.18L380,186.92h0l-22.77-41,7-3.9L387,183Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.16 189.53 387.22 191.68 385.41 190.5 387.16 189.53",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.33,
    y: 143.66,
    width: 9.39,
    height: 1.86,
    transform: "translate(-24.77 193.67) rotate(-29.08)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.33,
    y: 145.46,
    width: 9.39,
    height: 1.86,
    transform: "translate(-25.51 194.4) rotate(-29.08)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.38 149.48 361.02 148.01 367.8 163.64 366.8 164.13 358.38 149.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.72,194.88c7.9,7.67,39.38,3.56,59.45-2.46,3.82-1.14-8.52-35.11-12.45-33.47A106.51,106.51,0,0,1,330,163.48C328.87,163.68,287.07,186.47,295.72,194.88Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.17,160.37c-.29,3.8-9.61,2.29-9.61,2.29a7.06,7.06,0,0,1,2.54,4.06c.48,2.86-3.8,4.87-3.8,4.87a8.62,8.62,0,0,1,2,4.71c.19,2.78-3.84,5.42-3.84,5.42a7.64,7.64,0,0,1-.85,5.25c-2.59,4.16-10.1,3.63-14.81,4.23a97.58,97.58,0,0,0-15.59,3.6l-5.82-34.9s21.07-10.29,26.67-9.56C371.77,151,390.62,154.55,390.17,160.37Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.49,162.54c-4.86-1.85-10.15-2.54-15.26-3.14-.11,0-.13.16,0,.17,5.09.55,10.16,2.47,15.22,3.21A.13.13,0,0,0,380.49,162.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.2,171.19a13.44,13.44,0,0,0-3.51-.48c-1.26-.09-2.51-.15-3.76-.2-2.52-.09-5-.12-7.54-.07-.11,0-.14.17,0,.17q3.75.13,7.5.42,1.88.15,3.75.33a16.14,16.14,0,0,0,3.54.17A.18.18,0,0,0,379.2,171.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.35,181.72a9.15,9.15,0,0,0-3.18-.27l-3.44-.07c-2.29-.06-4.58-.12-6.86-.26-.12,0-.14.17,0,.18,2.32.15,4.64.34,7,.47l3.43.17a8.54,8.54,0,0,0,3.11-.11A.06.06,0,0,0,377.35,181.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.37,192.65C298.62,207,344.54,196,344.54,196l-.46-37.8s-12.31,5.49-12.65,4.86S288.12,178.25,293.37,192.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.1,193.35c-.37-5-1.11-25.62-1-30.08,0-.31.21-.38.24-.06,1.46,15,.82,25.18.93,30.12C339.3,193.46,339.11,193.48,339.1,193.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8,158.21a26.45,26.45,0,0,0-3.92,1.38c-1.15.45-2.3.89-3.45,1.36-2.48,1-4.95,2.08-7.4,3.17s-4.9,2.2-7.33,3.35-4.77,2.43-7.2,3.58c-.11,0,0,.22.1.17,2.45-1.11,5-2.06,7.47-3.1l7.29-3.09c2.43-1,4.87-2,7.3-3.07,1.19-.5,2.37-1,3.56-1.53a29.21,29.21,0,0,0,3.77-1.74A.26.26,0,0,0,343.8,158.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.7,195.18c0-.25-.13-.31-.2-.05l-.11.56c-1.56.26-7.26,1.44-8.65,1.72-2.92.57-5.79,1.28-8.74,1.65a111.65,111.65,0,0,1-12.36.89.1.1,0,0,0,0,.19,110.74,110.74,0,0,0,12.38-.35c3-.34,6-.82,9-1.43q2.22-.47,4.41-1a21.44,21.44,0,0,0,4.16-1.25.31.31,0,0,0,.16-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.79 194.71 378.2 195.56 395.6 144.38 435.19 143.53 417.79 194.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.5 194.65 380.91 195.5 398.31 144.32 437.9 143.47 420.5 194.65",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52,144.23a3.5,3.5,0,0,1-1.66,2.11c-.37.21-.48-.28-.11-.48a2.66,2.66,0,0,0,1.12-1.33c0-.09.07-.19.09-.28a1.89,1.89,0,0,0,0-1,.6.6,0,0,0-.23-.35l0,0-.05,0h-.07a.45.45,0,0,0-.28,0,1.15,1.15,0,0,0-.45.3,2.41,2.41,0,0,0-.38.54,2.75,2.75,0,0,0-.17.29l0,.07a.31.31,0,0,0-.05.1s0,0,0,.07h-.56a4,4,0,0,1,.51-1,2.13,2.13,0,0,1,1.5-1,.86.86,0,0,1,.9.79A2.33,2.33,0,0,1,402.52,144.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,144.17a3.54,3.54,0,0,1-1.66,2.1c-.37.21-.48-.28-.11-.48a2.62,2.62,0,0,0,1.12-1.33c0-.09.06-.19.08-.28a1.8,1.8,0,0,0,0-1,.61.61,0,0,0-.23-.34s0,0,0,0,0,0,0,0a.21.21,0,0,1-.08,0,.42.42,0,0,0-.27,0,1.11,1.11,0,0,0-.45.31,2.41,2.41,0,0,0-.39.53,2.85,2.85,0,0,0-.16.3l0,.07a.3.3,0,0,0,0,.1s0,0,0,.07h-.57a4.49,4.49,0,0,1,.52-1,2.16,2.16,0,0,1,1.5-1,.87.87,0,0,1,.9.79A2.37,2.37,0,0,1,405.62,144.17Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.71,144.1a3.51,3.51,0,0,1-1.65,2.11c-.37.21-.48-.29-.11-.49a2.65,2.65,0,0,0,1.12-1.32c0-.09.06-.2.08-.29a1.86,1.86,0,0,0,0-1,.6.6,0,0,0-.23-.35l0,0s-.05,0-.05,0h-.08a.47.47,0,0,0-.28,0,1.05,1.05,0,0,0-.44.3,2.25,2.25,0,0,0-.39.54,2.69,2.69,0,0,0-.16.29l0,.07a.42.42,0,0,0,0,.1.21.21,0,0,0,0,.07h-.56a4.1,4.1,0,0,1,.52-1,2.17,2.17,0,0,1,1.5-1,.88.88,0,0,1,.9.79A2.26,2.26,0,0,1,408.71,144.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.81,144a3.53,3.53,0,0,1-1.65,2.1c-.37.21-.48-.28-.12-.48a2.61,2.61,0,0,0,1.12-1.33,1.52,1.52,0,0,0,.09-.28,1.9,1.9,0,0,0,0-1,.55.55,0,0,0-.23-.34l0,0,0,0h-.08a.55.55,0,0,0-.28,0,1.27,1.27,0,0,0-.45.3,3.12,3.12,0,0,0-.38.54c-.06.09-.11.19-.17.3l0,.06a.49.49,0,0,0,0,.11s0,0,0,.06l-.56,0a4.05,4.05,0,0,1,.51-1,2.13,2.13,0,0,1,1.5-1,.87.87,0,0,1,.91.79A2.27,2.27,0,0,1,411.81,144Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,144a3.5,3.5,0,0,1-1.65,2.1c-.37.21-.49-.28-.12-.48a2.57,2.57,0,0,0,1.12-1.33c0-.09.07-.19.09-.28a1.9,1.9,0,0,0,0-1,.67.67,0,0,0-.23-.34l0,0-.05,0H414a.46.46,0,0,0-.28,0,1,1,0,0,0-.45.3,2.36,2.36,0,0,0-.38.53c-.06.09-.11.2-.17.3l0,.07,0,.1s0,0,0,.07h-.56a4.05,4.05,0,0,1,.51-1,2.19,2.19,0,0,1,1.5-1,.89.89,0,0,1,.91.79A2.38,2.38,0,0,1,414.91,144Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,143.9a3.52,3.52,0,0,1-1.65,2.11c-.38.21-.49-.29-.12-.48a2.61,2.61,0,0,0,1.12-1.33,2.46,2.46,0,0,0,.09-.29,1.86,1.86,0,0,0,0-1,.66.66,0,0,0-.23-.35l0,0-.05,0h-.07a.45.45,0,0,0-.28,0,1.15,1.15,0,0,0-.45.3,2.2,2.2,0,0,0-.38.54,2.75,2.75,0,0,0-.17.29l0,.07a.31.31,0,0,0-.05.1.25.25,0,0,0,0,.07h-.56a4.24,4.24,0,0,1,.51-1,2.15,2.15,0,0,1,1.5-1,.86.86,0,0,1,.9.79A2.22,2.22,0,0,1,418,143.9Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.11,143.84a3.51,3.51,0,0,1-1.66,2.1c-.37.21-.48-.28-.11-.48a2.62,2.62,0,0,0,1.12-1.33c0-.09.07-.19.09-.28a1.89,1.89,0,0,0,0-1,.58.58,0,0,0-.23-.34l0,0s0,0-.05,0h-.07a.54.54,0,0,0-.28,0,1.27,1.27,0,0,0-.45.3,2.66,2.66,0,0,0-.38.54,2.14,2.14,0,0,0-.17.3l0,.07a.19.19,0,0,0-.05.1s0,0,0,.07h-.57a4.49,4.49,0,0,1,.52-1,2.13,2.13,0,0,1,1.5-1,.86.86,0,0,1,.9.79A2.37,2.37,0,0,1,421.11,143.84Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.21,143.77a3.52,3.52,0,0,1-1.66,2.1c-.37.21-.48-.28-.11-.48a2.6,2.6,0,0,0,1.12-1.32c0-.1.06-.2.08-.29a1.79,1.79,0,0,0,0-1,.61.61,0,0,0-.23-.34s0,0,0,0l-.05,0h-.08a.43.43,0,0,0-.27,0,1,1,0,0,0-.45.3,2.41,2.41,0,0,0-.39.53c-.06.1-.11.2-.16.3l0,.07a.42.42,0,0,0,0,.1s0,.05,0,.07h-.57a4.49,4.49,0,0,1,.52-1,2.19,2.19,0,0,1,1.5-1,.88.88,0,0,1,.9.79A2.37,2.37,0,0,1,424.21,143.77Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,143.7a3.48,3.48,0,0,1-1.65,2.11c-.37.21-.48-.28-.11-.48a2.71,2.71,0,0,0,1.12-1.33c0-.09.06-.19.08-.28a1.9,1.9,0,0,0,0-1,.6.6,0,0,0-.23-.35l0,0,0,0h-.08a.47.47,0,0,0-.28,0,1.05,1.05,0,0,0-.44.3,2.46,2.46,0,0,0-.39.54,2.69,2.69,0,0,0-.16.29l0,.07a.69.69,0,0,0,0,.1s0,0,0,.07h-.56a4.24,4.24,0,0,1,.52-1,2.11,2.11,0,0,1,1.5-1,.86.86,0,0,1,.9.79A2.22,2.22,0,0,1,427.3,143.7Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.4,143.64a3.53,3.53,0,0,1-1.65,2.1c-.37.21-.48-.28-.12-.48a2.57,2.57,0,0,0,1.12-1.33,1.52,1.52,0,0,0,.09-.28,1.9,1.9,0,0,0,0-1,.61.61,0,0,0-.23-.34l0,0,0,0h-.08a.54.54,0,0,0-.28,0,1.18,1.18,0,0,0-.45.31,2.72,2.72,0,0,0-.38.53c-.06.09-.11.2-.17.3l0,.07a.3.3,0,0,0,0,.1.15.15,0,0,0,0,.07h-.56a4.05,4.05,0,0,1,.51-1,2.16,2.16,0,0,1,1.5-1,.87.87,0,0,1,.91.79A2.26,2.26,0,0,1,430.4,143.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.5,143.57a3.55,3.55,0,0,1-1.65,2.11c-.38.21-.49-.29-.12-.49a2.55,2.55,0,0,0,1.12-1.32c0-.09.07-.2.09-.29a1.86,1.86,0,0,0,0-1,.66.66,0,0,0-.23-.35l0,0-.05,0h-.07a.46.46,0,0,0-.28,0,1.15,1.15,0,0,0-.45.3,2.2,2.2,0,0,0-.38.54c-.06.09-.11.19-.17.29l0,.07a.47.47,0,0,0-.05.1s0,0,0,.07h-.56a4.05,4.05,0,0,1,.51-1,2.19,2.19,0,0,1,1.5-1,.89.89,0,0,1,.91.79A2.37,2.37,0,0,1,433.5,143.57Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.6,143.51a3.53,3.53,0,0,1-1.65,2.1c-.38.21-.49-.28-.12-.48A2.61,2.61,0,0,0,436,143.8c0-.09.07-.19.09-.28a1.9,1.9,0,0,0,0-1,.6.6,0,0,0-.23-.34l0,0-.05,0h-.07a.54.54,0,0,0-.28,0,1.27,1.27,0,0,0-.45.3,2.66,2.66,0,0,0-.38.54,2.14,2.14,0,0,0-.17.3l0,.06a.27.27,0,0,0,0,.11s0,0,0,.06l-.56,0a4.05,4.05,0,0,1,.51-1,2.13,2.13,0,0,1,1.5-1,.86.86,0,0,1,.9.79A2.25,2.25,0,0,1,436.6,143.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.36,155.05c1.87,4.38,6.79,9.92,7.07,13.44a4,4,0,0,1-2.41,4.19s3.43,1.89,3.16,5.13c-.14,1.67-2.93,2.91-2.93,2.91s2.68,1.63,2.26,4.5c-.33,2.28-3.07,3.19-3.07,3.19s1.84,2.76.76,5c-2.21,4.5-22,3.72-24.78-3.7-1.3-3.46,3.53-3,3.53-3s-6.78-2.33-6.73-6.42,6.3-3.12,6.3-3.12-6.56-2.31-6.07-6.55c.5-4.4,6.58-2.36,6.58-2.36s-4.29-3.16-3.17-6.32c1.84-5.21,9.91,1.75,14.31.89l2.68-7.08Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.08,161.45c-1.4-4.3,4.05-9.32,3.29-13.63-1-5.82-7.74-.42-9.52,7.91l-.24,6.7Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,188.61a.06.06,0,0,1,0,.11,34.39,34.39,0,0,1-20.36-2c-.2-.09-.14-.46.11-.4A70.06,70.06,0,0,0,439,188.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.34,180.77c.08,0,.09.12,0,.14-6.79,1.33-15.37.47-22.07-3.59-.23-.14-.3-.49,0-.35C422.92,179.33,433.94,181.06,440.34,180.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.63,167.79c6.58,3.64,13.66,4.81,21.11,5,.1,0,.08.14,0,.16-3.66.92-8.4.33-12.05-.45A19.89,19.89,0,0,1,418.5,168C418.4,167.93,418.49,167.71,418.63,167.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,123.75c.4,1,4.23,7.71,9,7.71,3,0,2.28-10.32,2.28-10.32l.05-.65.7-9-11.2-5.1-1.61-.66s0,2.48,0,5.56v.44c0,.18,0,.34,0,.5,0,.47,0,.94,0,1.4s0,.71,0,1.08l0,1.12A59.4,59.4,0,0,0,349,123.75Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16,111.28a18.12,18.12,0,0,0,12.14,9.21l.7-9-11.2-5.1-1.61-.66S348.16,108.2,348.16,111.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.42,100c-.4,15.85-9.95,17.4-13.36,17.31-3.11-.09-13.66-.77-14.89-16.58s6.27-20.63,13.37-20.81S373.83,84.1,373.42,100Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.64,96c-.37-.08-.7-.21-1.05-.32a1.73,1.73,0,0,1-1-.52.56.56,0,0,1,.06-.69,1.4,1.4,0,0,1,1.4-.21,2.05,2.05,0,0,1,1.22.83A.6.6,0,0,1,369.64,96Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.31,95.15a10,10,0,0,0,1.08-.14,1.82,1.82,0,0,0,1.09-.35.57.57,0,0,0,0-.69,1.4,1.4,0,0,0-1.35-.43,2.06,2.06,0,0,0-1.34.61A.6.6,0,0,0,359.31,95.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.24,99.33s-.09,0-.09.09c0,1.08-.24,2.31-1.24,2.61,0,0,0,.07,0,.06C361.12,102,361.39,100.36,361.24,99.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.34,98.15c-1.72-.24-2.06,3.23-.46,3.45S361.79,98.34,360.34,98.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.65,98.26c-.33.17-.66.49-1,.49s-.71-.4-.95-.77c0,0-.06,0-.06,0-.08.67.11,1.37.82,1.54s1.16-.39,1.39-1C359.86,98.39,359.77,98.2,359.65,98.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.23,99.73s.08.06.07.1c-.14,1.07-.13,2.32.8,2.78,0,0,0,.07,0,.06C366.92,102.38,366.92,100.72,367.23,99.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,98.71c1.74.05,1.51,3.52-.1,3.48S366.85,98.66,368.31,98.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,99c.26.2.51.56.84.6s.68-.31.95-.65c0,0,.05,0,.05,0,0,.67-.29,1.34-.94,1.43s-1-.52-1.09-1.19C368.81,99.08,368.91,98.9,369,99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,107.9c.22.28.42.67.81.75a2.82,2.82,0,0,0,1.19-.1,0,0,0,0,1,0,.06,1.44,1.44,0,0,1-1.44.39,1.15,1.15,0,0,1-.7-1.07C360.46,107.87,360.55,107.86,360.58,107.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41,104.39s.08,1.63,0,2.39c0,.07-.19.09-.45.08,0,0,0,0,0,0a3.62,3.62,0,0,1-3.39-1.65.08.08,0,0,1,.13-.09,5.4,5.4,0,0,0,3.21,1.22c.07-.2-.24-2.78-.12-2.78a6.86,6.86,0,0,1,1.69.54c-.08-3.39-.7-6.74-.73-10.12,0-.12.18-.14.2,0a54.73,54.73,0,0,1,1.25,10.87C367.21,105.25,365.7,104.55,365.41,104.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.51,106.41a3.92,3.92,0,0,1-1.61,1.14,1.7,1.7,0,0,1-1.07,0c-.76-.23-.75-.94-.58-1.54a4,4,0,0,1,.38-.91A5.06,5.06,0,0,0,364.51,106.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.9,107.55a1.7,1.7,0,0,1-1.07,0c-.76-.23-.75-.94-.58-1.54A1.82,1.82,0,0,1,362.9,107.55Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,98.41c1.74.23,7.13-3.59,8.91-11.82,0,0-2.11,7.28-2.89,8.26s3-2.15,4.55-8.78A27.53,27.53,0,0,0,361.74,91c3,1.51,4.91,1.86,5.18,1.68s-4.07-2.57-5-4.26c0,0,7.6,5.56,11.4,6.62.44.12,2.8-9-2.39-14s-15.48-2.76-18.51-.81c0,0-3.07-.17-7.19,3.6S343.18,98.15,345,98.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.88,100.08s-2.88-5.31-5.26-4.33-.58,8.4,1.93,9.67a2.68,2.68,0,0,0,3.73-1Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.19,97.86a0,0,0,0,0,0,.07c1.75.95,2.52,2.77,3,4.61a1.47,1.47,0,0,0-2.15-.65.05.05,0,0,0,0,.1,1.67,1.67,0,0,1,1.74.78,8,8,0,0,1,.69,1.55c.07.18.38.12.34-.07v0C347.13,101.87,345.68,98.38,343.19,97.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.39,442.55c2.32.75,68.3-.11,70.79-1.74,1-.6,1.39-10.22,1.58-21.86,0-.12,0-.25,0-.37,0-2.4.07-4.87.08-7.37,0-.35,0-.69,0-1,.09-16.8-.17-34.23-.17-34.23l-44.14.44,1.33,33.91.05,1.34.26,7,0,.72S70.11,431,67.56,433.08,63.08,441.81,65.39,442.55Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.83,414c0,1.56,0,3.09-.06,4.6,0,.12,0,.25,0,.37-.19,11.64-.62,21.26-1.58,21.86-2.49,1.63-68.47,2.49-70.79,1.74s-.36-7.39,2.17-9.46,27.66-13.71,27.66-13.71l0-.72L95,414.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.22,423.89q.25-.08.27-.15Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.12,442.66c2.32.75,68.63,0,71.14-1.65,1-.62,1.41-10.28,1.62-22l-42.75.38s-25.26,11.65-27.82,13.73S62.79,441.92,65.12,442.66Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.88,419c-.21,11.69-.66,21.35-1.62,22s-13.07,1.2-27,1.54l23.93-23.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,440c11.11-.4,56-1,67-.53.09,0,.09.06,0,.06-11,.65-55.86.86-67,.65C65.81,440.18,65.8,440,66,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.83,420.57c4.45-.11,9.62,1.4,12.43,5,.11.14-.09.3-.22.23a61.2,61.2,0,0,0-12.28-4.68A.28.28,0,0,1,90.83,420.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.41,422c4.45-.11,9.62,1.4,12.43,5,.11.14-.09.3-.22.23a61.2,61.2,0,0,0-12.28-4.68A.28.28,0,0,1,87.41,422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,423.33c4.45-.11,9.63,1.4,12.43,5,.11.14-.09.29-.22.23a61.2,61.2,0,0,0-12.28-4.68A.28.28,0,0,1,84,423.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.57,424.71c4.45-.11,9.63,1.4,12.43,5,.11.14-.09.29-.22.23a61.2,61.2,0,0,0-12.28-4.68A.28.28,0,0,1,80.57,424.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.23,185.88s-9.91,111.5-11.52,120c-.38,1.94-.61,12.48-.76,26-.34,29.55-.14,82.85-.14,82.85H92.3s1.38-92.35,3.44-109.35S111,185.88,111,185.88Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4,406.66c7.26-.15,5.17-.21,12.43-.28,3.55,0,26.9-.24,30.21.31a.08.08,0,0,1,0,.15c-3.31.55-26.66.35-30.21.31-7.26-.07-5.17-.13-12.43-.28A.11.11,0,0,1,94.4,406.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,353.86q.08-10.11.15-20.23c0-6.54,0-13.08.35-19.61.63-13.21,3.31-26.21,5.22-39.28s3.5-26.19,4.94-39.33c1.62-14.73,3-29.49,4.56-44.23,0-.1.16-.1.16,0-2.2,26.33-4.64,52.65-8.29,78.82q-1.35,9.76-3,19.5c-1.08,6.56-2.16,13.13-2.68,19.76s-.59,13-.66,19.54q-.1,10.11-.2,20.22c-.14,15-.29,38-.43,53a.23.23,0,0,1-.45,0C129.77,388.65,129.87,367.22,130,353.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,185.88s-19.71,111.5-21.32,120c-.38,1.94-.61,12.48-.76,26v0L116.77,185.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.4,446.48c2.37.58,68.12-4.94,70.49-6.74.91-.67.66-10.3,0-21.93,0-.12,0-.24,0-.36-.13-2.4-.27-4.86-.45-7.36l-.06-1c-1.09-16.77-2.59-34.13-2.59-34.13l-44,3.56,3.73,33.73.14,1.34.77,7,.07.72s-24.22,13.37-26.62,15.63S117,445.91,119.4,446.48Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.89,439.74c-2.37,1.8-68.12,7.32-70.49,6.74s-.88-7.35,1.49-9.59,26.62-15.63,26.62-15.63l-.07-.72-.47-4.22,42.66-3.56c.1,1.58.19,3.15.27,4.69,0,.12,0,.24,0,.36C190.55,429.44,190.8,439.07,189.89,439.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.86,426.46q.22-.09.24-.15Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.21,446.54c2.37.58,68.46-4.79,70.86-6.59.91-.67.69-10.34.09-22l-42.62,3.34s-24.39,13.37-26.8,15.62S116.84,446,119.21,446.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,443.81c11.06-1.17,55.77-4.85,66.79-5.17.09,0,.09.06,0,.07-10.93,1.4-55.67,4.72-66.77,5.29C119.72,444,119.71,443.84,119.94,443.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.33,422.72c4.43-.43,9.7.72,12.75,4.13.11.13-.08.29-.21.24a61.41,61.41,0,0,0-12.57-3.82A.28.28,0,0,1,143.33,422.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,424.33c4.43-.42,9.7.73,12.75,4.13.12.13-.07.3-.21.24A61.65,61.65,0,0,0,140,424.88.28.28,0,0,1,140,424.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7,425.94c4.43-.42,9.7.73,12.75,4.13.11.13-.08.3-.21.24a62,62,0,0,0-12.57-3.82A.28.28,0,0,1,136.7,425.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38,427.55c4.43-.42,9.7.73,12.75,4.13.12.13-.07.3-.21.24a61,61,0,0,0-12.57-3.81A.29.29,0,0,1,133.38,427.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.35,416.46l46.46-3.21s-12.49-99.91-12.72-106.18c-.35-9.32-4.82-47.77-8.57-78.9,0,0,7.11-16.86-6.2-42.32h-53.4s3.58,24.23,9.7,39.59a71.58,71.58,0,0,1,11.88,5.42s5.31,69.42,5.51,78.08C138.4,326.05,145.35,416.46,145.35,416.46Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61,408c7.23-.66,5.15-.57,12.38-1.15,3.54-.28,26.82-2.11,30.16-1.8.08,0,.09.14,0,.15-3.27.78-26.57,2.21-30.11,2.42-7.25.44-5.17.23-12.42.59A.11.11,0,0,1,146.61,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.6,224.39a87.28,87.28,0,0,1,13.9,6.47.16.16,0,0,1-.13.29c-4.68-2-9.46-3.94-14-6.2A.31.31,0,0,1,118.6,224.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.51,357.72q-2.19-21.32-4.33-42.64T168,272.64q-1.05-10.56-2.08-21.13c-.67-6.82-1.51-13.65-1.28-20.52.38-11.85,3.15-24.4-1-35.89a30.39,30.39,0,0,0-1.72-3.87c-.06-.11-.21,0-.16.1,5.63,11.23,3.23,24.26,2.47,36.25a123.73,123.73,0,0,0,.65,19.81l2,20.91q2,21.13,4.1,42.24t4.28,42.23c1.46,14.08,3,28.15,4.71,42.2.22,1.72.43,3.44.65,5.17,0,.09.17.09.16,0C179.4,386,178,371.85,176.51,357.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.73,292c-.8-12.92-1.7-25.84-2.79-38.74-.62-7.29-1.38-15-2.36-22.26,0-.07-.28-.23-.27-.16.69,12.92,2,26.42,2.94,39.32S136.88,296,137.62,309c.42,7.29.9,14.58,1.38,21.88,0,.13.2.12.2,0C139.06,317.88,138.53,305,137.73,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.79,212.92c-.26-2.19-.55-4.36-.79-6.55-.48-4.33-.9-8.67-1.33-13-.24-2.48-.4-5-.57-7.45a.1.1,0,0,0-.19,0,133.48,133.48,0,0,0,1.83,26.18,48.53,48.53,0,0,0,1.61,7.36.08.08,0,0,0,.16,0C124.45,217.25,124,215.08,123.79,212.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.18,206c-.39-4.44-.87-8.86-1.29-13.29-.23-2.55-.42-5.1-.67-7.64,0-.06-.09-.06-.09,0,0,4.44.28,8.89.53,13.32s.6,8.87,1.2,13.28c.34,2.54.72,5.08,1.11,7.61,0,.11.2.12.19,0C129.83,214.81,129.57,210.38,129.18,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,205.69l-9.65-.94-4-.39-6-.59-2.13-.2-4.27-.41-.41,0-.63-.06-.36,0-22.63-2.19-1-.1L119,200.6l-4.74-.46-.74-.07-.68-.07-.88-.09-2.76-.27c1-7.62,1.63-12.71,1.74-13.61a0,0,0,0,0,0,0c0-.11,0-.16,0-.16h53.4A71.47,71.47,0,0,1,171.43,205.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.68,135.55c-1.54,6.68-20.19,67.24-24,68.15-11.23,2.68-24.74,4.71-24.65-4.53.13-14.5,25.63-50.15,39.05-65C129.11,125.26,132.2,129,130.68,135.55Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.69,161.18l-17.38-10.69s9.74-12.41,16.32-18.85,11.23-6.11,8,7A194.82,194.82,0,0,1,123.69,161.18Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25,155.69c-2.33-1.47-4.71-2.88-7.11-4.23-1.19-.66-2.37-1.35-3.56-2s-2.53-1.24-3.76-1.91c-.09,0-.17.08-.09.13,1.17.69,2.3,1.46,3.47,2.15s2.43,1.38,3.65,2.07c2.41,1.35,4.86,2.65,7.33,3.88C124.25,155.83,124.32,155.73,124.25,155.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4,193.55s40.85,1.77,58.13-.28c0,0-11.82-49.92-24.42-63.37-5.73-6.13-11.33-5.19-16.08-1.25-1.18,1-15.86,19.62-17.11,26.11-1.1,5.75,3.57,12.12,3.57,12.12Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.14,146.92c.88-1.33,1.79-2.65,2.72-3.94.16-.46.34-.9.52-1.35a15.18,15.18,0,0,1,1-1.89,15.66,15.66,0,0,1-.7,2q-.13.27-.24.54,1.39-1.91,2.9-3.74c-1.84,2.94-3.84,5.77-5.69,8.69a38.82,38.82,0,0,0-2.58,4.46,14.48,14.48,0,0,0-.63,1.53,12.5,12.5,0,0,0,.38,8.1,26.54,26.54,0,0,0,1.55,4.06.09.09,0,1,1-.15.08,40.85,40.85,0,0,1-1.86-4.1,14,14,0,0,1-.89-4.29C109.17,152.9,111.28,150.13,113.14,146.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.78,
    y: 148.09,
    width: 12.26,
    height: 2.35,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.32,136.59c3.9,5.36,23.91,27.46,24.64,29.52s-3.89,6.58-3.81,7.43c.31,3.45,7.78,26.47,10.77,24.13,3.93-3.07,20.61-25.14,18.25-34.69s-41.31-32.48-47.48-34.47S137.47,131.31,141.32,136.59Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,156.73l11.36-16s-12.71-8.33-21.19-11.92-12.69-1.57-4.91,9.42A193.9,193.9,0,0,0,157,156.73Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,139.74c-1.8,2.08-3.55,4.22-5.25,6.39-.83,1.07-1.69,2.13-2.5,3.22s-1.61,2.31-2.45,3.43c-.06.08,0,.18.11.11.86-1.06,1.79-2,2.65-3.11s1.73-2.2,2.59-3.3q2.55-3.27,4.95-6.66C165.17,139.75,165.09,139.67,165,139.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.06,156.81c-1.75-2.31-3.8-4.37-5.68-6.57s-3.75-4.44-5.54-6.72a.05.05,0,1,0-.09.06c.83,1.18,1.64,2.39,2.51,3.54.44.57.89,1.13,1.34,1.69-.22-.18-.43-.37-.66-.54-.68-.52-1.41-1-2.14-1.45,0,0-.07,0,0,.06a24.28,24.28,0,0,0,2,1.67c.51.37,1,.72,1.54,1.07l.8,1a46.75,46.75,0,0,0,5.86,6.32C157,157,157.11,156.88,157.06,156.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.13,206.41c-2.67-1.81,1-3.92,1-3.92s-6,1.77-8-1.16,2.56-5.23,2.88-5.4c-.31.09-5.87,1.58-7.61-1.58s3.13-4.91,3.45-5c-.33,0-4.65-.2-5.43-2.89-1.34-4.64,11.1-5.17,13.78-8,0,0-1.2-6.11-1.29-6.29a7,7,0,0,0,3.53,3c2.69.76,5.11,1.2,6.21,2.49a3.54,3.54,0,0,1,.4,4.2s3.4-.4,4.84,2c.74,1.26-.6,3.56-.6,3.56a4.21,4.21,0,0,1,3.88,2.05c.93,1.79-.57,3.82-.57,3.82s2.72,1,3.07,3.17C183.34,200.8,168.86,210.28,163.13,206.41Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.37,193.68a0,0,0,1,1,.06.06,30,30,0,0,1-15.5,8.88c-.19,0-.33-.25-.13-.33A61.39,61.39,0,0,0,179.37,193.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.33,187.43s.12,0,.07.1a28.1,28.1,0,0,1-17.51,8.64c-.23,0-.46-.2-.19-.25C163.21,195.24,171.93,190.88,176.33,187.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.31,189.21c6.53-.74,12.15-3.5,17.53-7.17.07,0,.13.06.08.11-2.14,2.51-5.81,4.49-8.79,5.79a17.41,17.41,0,0,1-8.79,1.5C154.22,189.43,154.17,189.22,154.31,189.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73,193.31a4.16,4.16,0,0,0,1-4.26,3.12,3.12,0,0,0-1.52-1.56,5.45,5.45,0,0,0-2.55-.23,4.07,4.07,0,0,0,.07-4.61,3.06,3.06,0,0,0-2-1.06,10.41,10.41,0,0,0-2.66.11,3.6,3.6,0,0,0,.77-3.15,3.9,3.9,0,0,0-2.4-2.63,18.41,18.41,0,0,0-4.21-1,9.39,9.39,0,0,1-2.15-.59,4.24,4.24,0,0,1-1.79-1.6c-.08-.13-.07,0,0,.11a5.29,5.29,0,0,0,1.06,1.26,6.55,6.55,0,0,0,1.45.94,28.87,28.87,0,0,0,4,1.18,5.56,5.56,0,0,1,3,2,3.36,3.36,0,0,1,.11,3.51s0,.14.09.13a9.37,9.37,0,0,1,2.37.27,3.27,3.27,0,0,1,1.66,1,4.3,4.3,0,0,1,.21,4.28,7.58,7.58,0,0,1,2.49.64,3.09,3.09,0,0,1,1.17,1.31,3.69,3.69,0,0,1-.39,3.87.07.07,0,0,0,0,0h0v0a.09.09,0,0,0,0,.05h0s.87.36.91.36,0,0,0,0A5.77,5.77,0,0,0,179.73,193.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.29,
    y: 155.53,
    width: 36.82,
    height: 47.93,
    transform: "translate(-50.27 41.79) rotate(-18.01)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.47,
    y: 154.28,
    width: 17.45,
    height: 5.29,
    transform: "translate(242.19 275.33) rotate(161.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.85 155.89 95.89 155.23 95.14 152.91 100.1 151.29 100.86 153.61 102.9 152.94 101.52 148.72 92.44 151.68 93.85 155.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.83,168.38a3.82,3.82,0,0,1,.77,4.28,5.62,5.62,0,0,1,3.3,2c1.38,1.87-.94,4.86-.94,4.86a6.94,6.94,0,0,1,3.15,2.63c1.15,1.92-.76,5.27-.76,5.27a6.11,6.11,0,0,1,1.31,4.05c-.32,3.91-5.65,6.65-9,8.43s-14.58,3.65-16.68,4.23L93.39,182.58s12.83-12.25,17.08-13.78C114.06,167.52,121.65,166.36,123.83,168.38Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.91,181.16c-3.84,3-15.33,14.63-12.52,20.43s12.14,5.1,25.08,1.95Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.26,172.39c-4.13.45-7.91,2.1-11.78,3.54-.08,0,0,.16,0,.13,3.83-1.47,7.9-2.16,11.78-3.48C124.42,172.55,124.38,172.38,124.26,172.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.74,179.24a10.58,10.58,0,0,0-2.67.93c-.93.4-1.85.81-2.76,1.24q-2.73,1.28-5.4,2.7c-.08,0,0,.17,0,.13,1.82-.85,3.65-1.67,5.5-2.44.93-.39,1.86-.76,2.79-1.14a12.09,12.09,0,0,0,2.59-1.17A.14.14,0,0,0,126.74,179.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.27,187.41a7.72,7.72,0,0,0-2.36,1l-2.48,1.2c-1.65.8-3.31,1.59-5,2.33-.08,0,0,.17,0,.13,1.72-.74,3.44-1.46,5.14-2.21l2.51-1.13a7.05,7.05,0,0,0,2.18-1.21A.06.06,0,0,0,129.27,187.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4,181.36a37.12,37.12,0,0,0-3.81,3.32l-.9,1-.39.25c-.55.37-1.08.76-1.59,1.18a30,30,0,0,0-2.78,2.63.07.07,0,0,0,.11.1,25.83,25.83,0,0,1,3-2.47l.42-.29c-.5.57-1,1.15-1.44,1.75a48.51,48.51,0,0,0-3.33,5c-.05.08.08.15.12.07,1.86-3.06,10-11.28,10.88-12.26S95.08,180.8,94.4,181.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,132c.16-4.95-5.2-6.52-8.92-6.89-4.4-.44-7.65,1-9.6,5.31-2.06,4.56-2.33,9.78-3,14.72a.72.72,0,0,1-1.43-.18c.8-5.69,1.35-16.67,6.87-19.94,5.07-3,17.81-1.23,17.54,7.16,0,.93-1.46.75-1.43-.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.12,147.33a3.33,3.33,0,1,0,3.71-2.88A3.33,3.33,0,0,0,117.12,147.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.43,147.5a2,2,0,0,0,4,.49,2,2,0,1,0-4-.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57,147.64c-3.15,14-2.46,17.38-1.25,18.93a9.09,9.09,0,0,0,3.36,2.51l.38-.93-.19.47.19-.47a8.4,8.4,0,0,1-2.94-2.2c-.88-1.12-1.68-4.22,1.43-18.09Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.48,167.9h0a1.08,1.08,0,0,0,.47,1.44l1.2.6a1.08,1.08,0,0,0,1.45-.47h0a1.08,1.08,0,0,0-.48-1.44l-1.2-.61A1.08,1.08,0,0,0,139.48,167.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.64,147.65c3.13,10.36,4,16.06,2.75,17.94a8.38,8.38,0,0,1-2.77,2.41l.45.9a9.15,9.15,0,0,0,3.16-2.75c1.5-2.24.74-7.68-2.63-18.79Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.18,167.63h0a1.07,1.07,0,0,1-.37,1.47l-1.15.7a1.09,1.09,0,0,1-1.48-.37h0a1.07,1.07,0,0,1,.37-1.47l1.15-.7A1.09,1.09,0,0,1,149.18,167.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,146.91a57.24,57.24,0,0,0-2.05-6.77,6,6,0,0,0-2.11-2.4c-.2,0-.17-1.78-.12-3.22,0-1.27.12-2.76-.2-3.15a1,1,0,0,0-1.38,0c-.34.38-.3,1.87-.3,3.14,0,1.45,0,3.21-.23,3.21a6.69,6.69,0,0,0-2.07,2.37,47.92,47.92,0,0,0-2.15,6.91c-.27,1.5.23,1.67.66,1.8.61.18,1-.24,1.39-1.91.66-2.63,1.44-7.05,3.26-7.11h0c1.8.12,2.7,4.74,3.38,7.31.42,1.61.77,1.75,1.38,1.59C148.83,148.54,149.27,148.34,148.93,146.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.69,128.49c-.27,1.07-5.51,8-10.42,7.69-1.61-.11-1.45-8.87-1.45-8.87l-.13-.65-1.9-9.1,10.75-6.68,1.55-.88s.35,2.52.76,5.67q0,.21.06.45c0,.17.06.34.08.51.07.47.13,1,.19,1.42s.09.72.12,1.11l.12,1.14A61.57,61.57,0,0,1,139.69,128.49Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.85,115.67a18.62,18.62,0,0,1-11.16,11l-1.9-9.1,10.75-6.68,1.55-.88S138.44,112.52,138.85,115.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.12,100c-3.47,15.94,5.68,19.82,9.11,20.56,3.12.68,13.83,2.59,18.93-12.9S142,85.54,134.9,83.61,118.6,84.09,115.12,100Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,97.71c.38,0,.74,0,1.12,0a1.84,1.84,0,0,0,1.15-.24.58.58,0,0,0,.13-.69,1.44,1.44,0,0,0-1.33-.61,2.15,2.15,0,0,0-1.44.48A.63.63,0,0,0,120,97.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.09,99.93c-.37-.12-.68-.29-1-.44a1.91,1.91,0,0,1-1-.65.58.58,0,0,1,.14-.7,1.44,1.44,0,0,1,1.46-.06,2.12,2.12,0,0,1,1.15,1A.62.62,0,0,1,131.09,99.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79,103.36s.07.07.06.11c-.27,1.08-.4,2.36.5,2.93,0,0,0,.08,0,.06C127.17,106,127.36,104.34,127.79,103.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,102.44c1.77.25,1.14,3.78-.5,3.55S127.52,102.23,129,102.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67,102.75c.27.25.51.66.87.76s.81-.19,1.16-.49c0,0,.06,0,.05,0-.11.68-.49,1.32-1.24,1.29s-1-.71-1.09-1.42C129.41,102.81,129.56,102.65,129.67,102.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.45,101.88s-.09,0-.1.08c-.15,1.1-.51,2.34-1.56,2.53,0,0,0,.07,0,.07C121,104.59,121.49,103,121.45,101.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.67,100.57c-1.74-.43-2.48,3.07-.87,3.48S122.13,100.94,120.67,100.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.89,100.65c-.32.13-.66.41-1,.36s-.59-.5-.76-.91c0,0,0,0-.06,0-.16.67-.09,1.41.53,1.68s1.12-.24,1.42-.88C120.07,100.81,120,100.6,119.89,100.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,112.33c-.3.22-.61.54-1,.53a3,3,0,0,1-1.15-.44s-.07,0-.06,0a1.48,1.48,0,0,0,1.32.78,1.18,1.18,0,0,0,1-.85A.06.06,0,0,0,125.47,112.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.59,109.75a4.5,4.5,0,0,0,1.4,1.81,2.07,2.07,0,0,0,1.18.38c.93,0,1.15-.8,1.17-1.52a5.23,5.23,0,0,0-.12-1.14A5.88,5.88,0,0,1,121.59,109.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,111.56a2.07,2.07,0,0,0,1.18.38c.93,0,1.15-.8,1.17-1.52A2.12,2.12,0,0,0,123,111.56Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.66,107.52a23.67,23.67,0,0,0-.68,2.35c0,.07.16.14.42.21h0a3.72,3.72,0,0,0,3.81-.69c.07-.07,0-.16-.09-.13a5.62,5.62,0,0,1-3.52.32c0-.22,1-2.69.89-2.72a7.07,7.07,0,0,0-1.82.06c1-3.33,2.57-6.48,3.53-9.81A.11.11,0,0,0,124,97a57.22,57.22,0,0,0-4.26,10.41C119.64,107.86,121.33,107.59,121.66,107.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.59,108c-2.6-.31-2.11-5.82-2.11-5.82s-5.22-1-5.44-8.88a11.75,11.75,0,0,0,1.07,6.67s-9-2.82-11.34-11.3c0,0,.76,4.24,1.93,5.92a11,11,0,0,1-4.9-5.36s-2.5,4.12-4,5.1c0,0,1.37-21.52,20.54-10.6,0,0,8.47,1.65,10.34,9.71S141.59,108,141.59,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.91,113.56a3.13,3.13,0,0,1-.77.1,2.64,2.64,0,0,1-.77-.08,2.3,2.3,0,0,1-.89-.42,2.86,2.86,0,0,1-.55-.55,3.27,3.27,0,0,1-.5-1l1.45-4.21s4.19-4.59,6.31-3S144.73,112.91,141.91,113.56Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.12,106.35s0,.06,0,.07c-2,.52-3.2,2.14-4.13,3.87a1.52,1.52,0,0,1,2.31-.12s0,.11-.06.09a1.69,1.69,0,0,0-1.93.35,8.54,8.54,0,0,0-1.08,1.38c-.11.16-.4,0-.31-.16l0,0C140.2,109.38,142.5,106.26,145.12,106.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.77,112.85a.74.74,0,0,1-1,.47.76.76,0,0,1-.48-1,.77.77,0,0,1,1-.47A.75.75,0,0,1,141.77,112.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.46,111.92a.53.53,0,0,1-1-.35.53.53,0,1,1,1,.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.76,86.55c-1.72-2.3-.7-9.24,3-11.8,5.08-3.53,13.39,3,10.32,9.25S143.09,88.33,141.76,86.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,76.3a12.3,12.3,0,0,0-5.23-2.93,4.8,4.8,0,0,0-2.79.13,4.93,4.93,0,0,0-2.2,1.7,11.46,11.46,0,0,0-1.43,2.57,12.9,12.9,0,0,0-.85,2.86,10.16,10.16,0,0,0,.67,5.92,8.82,8.82,0,0,1-1.45-6,12.21,12.21,0,0,1,.75-3.1,11.28,11.28,0,0,1,1.53-2.83,5.71,5.71,0,0,1,2.67-2,5.43,5.43,0,0,1,3.29,0A10.31,10.31,0,0,1,153.59,76.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.23,464c-2.42.78-71.47-.12-74.08-1.82-1-.63-1.46-10.7-1.66-22.89V439c-.05-2.51-.08-5.09-.09-7.71,0-.36,0-.72,0-1.08l3.35-35.83,46.19.47-4.55,35.48-.06,1.41L288,439l0,.76S314.29,452,317,454.13,321.65,463.26,319.23,464Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.23,464c-2.42.78-71.47-.12-74.08-1.82-1-.63-1.46-10.7-1.66-22.89V439c-.05-2.51-.08-5.09-.09-7.71,0-.36,0-.72,0-1.08l45,.12-.06,1.41L288,439l0,.76S314.29,452,317,454.13,321.65,463.26,319.23,464Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.24,464c-1.25.4-20,.36-38.35,0-3.69-.07-7.35-.16-10.85-.25-13.07-.36-23.88-.9-24.88-1.56s-1.45-10.41-1.65-22.37c0-.17,0-.34,0-.51s0-.26,0-.39h0L288,439l0,.76S314.3,452,317,454.12,321.65,463.26,319.24,464Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.48,461.35c-11.63-.44-58.61-1.1-70.14-.65-.1,0-.1.07,0,.07,11.52.69,58.5,1,70.14.77C318.73,461.53,318.73,461.36,318.48,461.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,439.22c-4.57-.91-10.18-.28-13.72,2.94-.14.12,0,.32.19.27A65.23,65.23,0,0,1,293,439.8.29.29,0,0,0,293,439.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.28,441.26c-4.57-.92-10.18-.28-13.72,2.93-.14.13,0,.32.19.28a64,64,0,0,1,13.51-2.63A.29.29,0,0,0,296.28,441.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.56,443.29c-4.57-.91-10.18-.28-13.72,2.94-.14.12,0,.32.19.27a65.23,65.23,0,0,1,13.51-2.63A.29.29,0,0,0,299.56,443.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.89,464c-3.69-.07-7.35-.16-10.85-.25-13.07-.36-23.88-.9-24.88-1.56s-1.45-10.41-1.65-22.37c0-.17,0-.34,0-.51s0-.26,0-.39h0C249.64,443.22,271.12,457.52,280.89,464Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.07,439.19H241.34S251.36,323,251,321c-.5-2.6-3.44-14.36-7.35-29.72-1.22-4.8-2.54-10-3.91-15.3-3.71-14.45-7.8-30.25-11.36-44-5.34-20.59-9.52-36.58-9.52-36.58H261s4.91,15.57,11.1,35.83c10.09,32.93,23.57,78.24,24.9,89.26C299.13,338.3,291.07,439.19,291.07,439.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.87,430.7c-7.59-.16-5.41-.22-13-.29-3.72,0-28.14-.25-31.62.32-.07,0-.07.15,0,.16,3.48.57,27.9.36,31.62.33,7.6-.08,5.42-.14,13-.3A.11.11,0,0,0,288.87,430.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.32,313.91c-1.63-7.19-4.06-14.24-6.18-21.29q-6.46-21.51-13-43-3.27-10.75-6.56-21.48c-1.12-3.61-2.23-7.23-3.36-10.83s-2.36-7-3.36-10.59c-.41-1.45-.63-.66-.11,1.18,1,3.71,2.08,7.42,3.17,11.12q3.21,11,6.46,22,6.47,21.84,13,43.67,3.29,10.95,6.58,21.89a89.58,89.58,0,0,1,2.69,10.58,48.81,48.81,0,0,1,.44,11.33c-.48,7.61-1.36,15.2-2.06,22.8s-1.41,15.21-2.11,22.82q-2.11,22.69-4.17,45.41c-.17,1.92-.34,3.84-.49,5.76-.05.65.41.72.47.11,1.64-15,3.42-30.12,4.82-45.11s2.8-29.84,4.19-44.76c.35-3.74.75-7.49.75-11.26A45.59,45.59,0,0,0,260.32,313.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.19,195.42c-2.92,22.64-8.5,65.08-12.57,95.87-9.5-37.31-24.79-95.87-24.79-95.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.55,464.7c-2.42.79-71.48.15-74.09-1.55-1-.63-1.49-10.69-1.74-22.87v-.39c-.06-2.51-.1-5.09-.12-7.71,0-.36,0-.72,0-1.08-.16-17.58,1.1-35.83,1.1-35.83l45.14.3-1.26,35.49,0,1.41-.25,7.34,0,.76s26.32,12.07,29,14.23S269,463.92,266.55,464.7Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.55,464.7c-2.42.79-71.48.15-74.09-1.55-1-.63-1.49-10.69-1.74-22.87v-.39c-.06-2.51-.1-5.09-.12-7.71,0-.36,0-.72,0-1.08l45,0,0,1.41-.25,7.34,0,.76s26.32,12.07,29,14.23S269,463.92,266.55,464.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.55,464.7c-2.42.79-71.48.15-74.09-1.55-1-.63-1.49-10.69-1.74-22.87v-.39l44.55-.08,0,.76s26.32,12.07,29,14.23S269,463.92,266.55,464.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.79,462c-11.64-.4-58.61-.89-70.15-.4-.09,0-.09.07,0,.08,11.53.64,58.51.75,70.15.51C266,462.2,266,462,265.79,462Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,440c-4.57-.89-10.18-.24-13.71,3-.14.12,0,.32.19.27a64.49,64.49,0,0,1,13.49-2.68A.29.29,0,0,0,240.23,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52,442c-4.58-.9-10.19-.25-13.72,3-.13.13,0,.32.2.28a63.85,63.85,0,0,1,13.49-2.68A.29.29,0,0,0,243.52,442Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8,444c-4.57-.9-10.18-.24-13.71,3-.14.12,0,.31.19.27a64.58,64.58,0,0,1,13.5-2.68A.29.29,0,0,0,246.8,444Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.62,195.42s-1,20.17-5.59,36.14c-.37,1.32-.77,2.62-1.2,3.86a75.35,75.35,0,0,0-12.15,6.25s-.49,16.22-1,34.32c-.54,20.22-1.1,42.79-1,47.57.43,17.91-2.24,116.36-2.24,116.36l-49.72.2s9-109.95,8.93-116.5c-.1-10.55,2.41-57.14,4.34-91.12a267.63,267.63,0,0,1,4.65-37.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.78,431.07c-7.6-.13-5.41-.2-13-.24-3.72,0-28.15-.13-31.62.46-.07,0-.07.15,0,.16,3.48.56,27.91.24,31.62.19,7.6-.1,5.42-.16,13-.35A.11.11,0,0,0,234.78,431.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.36,202.63c-.91,27.74-1.88,55.48-3.12,83.21s-7.78,127.41-9.45,142.88c0,.1.15.14.16,0,3.62-27.51,5.64-68.24,7.42-95.93s3-55.42,3.93-83.15c.53-15.69.94-31.38,1.41-47.06C206.72,202.38,206.37,202.4,206.36,202.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.89,234.22a92,92,0,0,0-14.21,7.45.16.16,0,0,0,.15.29c4.79-2.33,9.69-4.57,14.35-7.17A.32.32,0,0,0,254.89,234.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.17,217.11c-.33,1.77-.76,3.52-1.14,5.28s-.62,3.33-1.05,5a8.52,8.52,0,0,1-2.31,4.15c-.65.6-1.36,1.13-2,1.69-.37.29-.78.58-1.16.88,0-.24.09-.47.13-.71.12-.67.23-1.34.34-2,.25-1.49.49-3,.72-4.48.45-2.93.86-5.89,1.47-8.79a.09.09,0,0,0-.18-.05c-.73,2.88-1.54,5.72-2.17,8.62-.31,1.43-1.43,8.45-1.48,8.95s-.09,1-.11,1.54a6,6,0,0,0,0,1.58c0,.13.18.11.24,0h0a6.71,6.71,0,0,0,.44-1.53c.13-.5.24-1,.33-1.52,0-.18.06-.37.09-.56.69-.42,1.33-1,2-1.45s1.41-1,2.07-1.55a7.89,7.89,0,0,0,2.52-3.94,28.61,28.61,0,0,0,.83-5c.22-2,.39-4,.66-6C255.37,217,255.19,217,255.17,217.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.15,134.86a0,0,0,0,0-.09,0,5.71,5.71,0,0,1-2.53,5.77,9.75,9.75,0,0,1-6.47,1.45,19.78,19.78,0,0,1-6.72-2c-1.9-1-4.09-2.61-4.31-4.89,0-.11-.18-.1-.17,0a7.68,7.68,0,0,0,2.27,4.62,12.78,12.78,0,0,0,5.46,2.68c3.81,1,8.77,1.12,11.45-2.32A5.94,5.94,0,0,0,251.15,134.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.69,217.27c-1.73,1.48-67.13,3.55-67.44,3.06s9-74.92,34.14-87.4c5.56-2.76,14.21,0,15.41,1.59C259.84,147.56,268.78,216.34,267.69,217.27Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.44 148.22 245.15 142.76 249.8 147.49 248.66 151.58 244.41 152.07 242.44 148.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.41 152.07 241.7 199.74 247.17 214.87 253.54 199.09 248.66 151.58 244.41 152.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.86,131.76a306.27,306.27,0,0,1,4.42,37.43c1.95,47.85-1.67,132.77-3,139-.77,3.55-41.95-2.83-41.95-2.83s3.76-98,17.46-136.51C222.5,133.13,232.86,131.76,232.86,131.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.55,250c-.24,7.57.11,16.14,1.72,17.72,3,2.95,11,2.7,13.57,2.68s11.52,0,13.63-4.67c.94-2.05,1.18-12.62,1.16-16.36,0-1.52-.36-9-.47-9.83,0-.2-.56-.17-.58,0-.13.85,0,4-.09,4.54-14.49,1.87-23.45.31-28.1-.59,0-1.39,0-2.48,0-3.88a79,79,0,0,0,13.73,1.3,149,149,0,0,0,15-1.07c.12,0,0-.57-.14-.57-1.89,0-8.43.67-15,.67a119.39,119.39,0,0,1-14.09-1.1C201.66,238.88,201.66,246.39,201.55,250Zm2.6,16.85c-1.6-1.83-1.8-7.12-1.8-10.28,0-4.36,0-7.84,0-12.19,11.16,2.59,23.43,1.32,28.09.37,0,.19.08,9.38,0,12.31-.11,3.73-.23,7.12-1.67,9.06-1.23,1.66-4.7,3.34-12.68,3.33C210.35,269.45,205.48,268.4,204.15,266.86Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,133.88s7.94,35.23,9.09,40.93,10,124.19,12,128.42c.7,1.44,23-5,23-5s-35.35-145-37.75-152C251.23,134.17,249,133.88,249,133.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.76,137.19c1.65,5.16,7.93,23.28,11.17,36.21,2.17,8.67,2.76,15.88,3.23,17.8,0,0-19.86-7.72-24.42-8-7-.44-19.16,13.55-16.51,15.56C227.4,201.9,247.52,213,263.87,217c8.89,2.22,26.51-8.19,25.72-17.36-1.12-12.86-22.15-47.84-30.34-57.89C255,136.57,247.76,130.9,249.76,137.19Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.66,202.45c-1,9.16-12.92,16.2-19.61,16.21-11.53,0-45.4-12.09-45.4-12.09l14.94-25s23,9.37,23.56,9.63v0c-.16-.69-4.64-22.75-6.8-30.11-.11-.4-.25-.82-.37-1.25-.62-2-1.49-4.73-2.44-7.65v0c-.53-1.61-1.1-3.29-1.65-5h0c-2.41-7.2-4.77-14.06-4.77-14.06,3.91.88,7.68,3.19,13.68,10.29S292.26,187.34,290.66,202.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92,201.52c1.07-1.77,2.15-3.53,3.21-5.3s2.11-3.45,3.18-5.17a62.69,62.69,0,0,0,3.17-5.44s0-.06-.06,0a47,47,0,0,0-3.49,4.88q-1.69,2.59-3.34,5.22c-1.08,1.72-2.12,3.45-3.15,5.2a44.9,44.9,0,0,0-2.93,5.58c0,.07.07.16.13.08A54.08,54.08,0,0,0,234.92,201.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,218.21a11.41,11.41,0,0,1-5.83.18c-1.11-.16-6-1.09-6.58-1.07-.1,0-.09.2,0,.21.83.17,5.83,1.28,7.09,1.49,1.84.32,3.82.52,5.35-.75A0,0,0,0,0,274.27,218.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.1,195.42l-6.94-4.22h0v0c-.16-.69-4.64-22.75-6.8-30.11-.11-.4-.25-.82-.37-1.25-.62-2-1.49-4.73-2.44-7.65Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.84,198.93a59.25,59.25,0,0,0-6-4.42c-1-.67-2.11-1.3-3.21-1.87s-2.43-1.08-3.59-1.69c-.09,0-.16.09-.08.14,1.09.57,2.11,1.34,3.16,2s2.17,1.35,3.27,2c2.17,1.28,4.29,2.63,6.43,3.93C276.83,199.05,276.89,199,276.84,198.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.11,193.83c-1.8-.09-12.48-3.63-14.15-2.24-10.17,8.5-13.11,6.49-15.23,7.55-16.41,8.19-38.25,17.65-45.82,17.26-11.48-.59-15.47-10.49-13-19.47,4.85-17.76,31.2-51.38,42.73-60,6.11-4.58,5.21,2.83,2.32,10.77-1.7,4.66-4.59,11.56-7.52,18.33-2.6,6-9.45,21.43-9.58,21.8h0l0,0s0,0,.13,0c.51-.06,14.46-5.65,28.32-8.35,4.88-1,15-2.11,18.5-.3,2.08,1.09,2,2.36,2,2.36a5.3,5.3,0,0,1,3.44,1.54,5.11,5.11,0,0,1,1.42,2.48,5.36,5.36,0,0,1,2.77,1.52,4.92,4.92,0,0,1,1.11,2.74C270,190.68,270.11,193.83,270.11,193.83Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.79,181a27,27,0,0,0-4.31.22c-.1,0-.1.17,0,.16,1.41-.07,2.82,0,4.23,0s2.81.09,4.21.2c0,0,0,0,0,0A22.11,22.11,0,0,0,254.79,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.64,185.51a17.35,17.35,0,0,0-7.55-1.12.08.08,0,0,0,0,.15,29.91,29.91,0,0,1,7.54,1S263.66,185.52,263.64,185.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.52,189.77a17,17,0,0,0-7.09-1.77c-.1,0-.14.13,0,.15a41.91,41.91,0,0,1,7.09,1.73C267.54,189.9,267.58,189.8,267.52,189.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6,179.64a31,31,0,0,0-3.6.58c-1.26.23-2.52.5-3.76.83a69.21,69.21,0,0,0-7.3,2.4.08.08,0,1,0,0,.15c2.43-.69,4.87-1.33,7.32-1.94,1.2-.3,2.4-.63,3.6-.94s2.51-.55,3.72-.93C237.7,179.77,237.69,179.63,237.6,179.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,181.65a13.47,13.47,0,0,1,3.7-.64l12.83,25s-40.17,11.81-48.3,12.15a16.13,16.13,0,0,1-16.48-16.71c.64-14.26,25.92-47.09,38.4-59.63,5.72-5.74,12.23-9.77,13.76-8.68,1.81,1.28-2.06,8.7-4.2,14.28-4,10.31-17.71,40.48-17.71,40.48S224.9,182.48,228,181.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.52,181c-2.22,0-12,2.76-16.82,4.5a80.94,80.94,0,0,0-13.84,6.44c-2.49,1.47-4.86,3.09-7.21,4.77-.08.06,0,.19.08.14a141.87,141.87,0,0,1,27.55-12.92c2.75-.89,7.45-2.18,10.11-2.71C232.14,181.05,231.59,181,231.52,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,159.33c-.66.93-1.32,1.86-1.89,2.84l-.08.14q1.35-3.39,2.59-6.84c.05-.14-.18-.23-.25-.09-3.89,8.36-7.54,16.83-11.1,25.34-1,2.37-1.89,4.78-2.81,7.19,0,.08.1.13.14.06,1.05-2.05,2.12-4.09,3.09-6.17s1.9-4.21,2.83-6.32q2.43-5.53,4.69-11.14c.44-.64.88-1.28,1.3-1.94.61-1,1.13-2,1.65-3C223.57,159.31,223.42,159.24,223.35,159.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.23,200.15c-.94-1.84-1.86-3.68-2.8-5.53s-1.82-3.61-2.72-5.42a61.53,61.53,0,0,0-2.93-5.57s-.08,0-.07,0a46.18,46.18,0,0,0,2.3,5.54c.87,1.88,1.77,3.74,2.67,5.6s1.81,3.62,2.75,5.42a45.53,45.53,0,0,0,3.19,5.44.08.08,0,0,0,.14-.07A55.82,55.82,0,0,0,235.23,200.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.05,206.06c-1-2.41-2.75-4.81-4-7.11,0-.09-.18,0-.13.08,1.11,2.16,2.11,4.47,3.17,6.66-5.54,1.91-11.39,3.55-17,5.18s-11.57,3.22-17.44,4.54c-3.28.74-6.57,1.55-9.87,2.21-.2,0-.16.21.05.18a146.44,146.44,0,0,0,17.49-3.55c5.87-1.48,11.68-3.18,17.47-5C238.05,208.29,245.14,206.26,245.05,206.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.56,141.85c-1.1.45-9.55-1-12.68-5.41-.21-.3-.12-3.74-.21-7.93-.07-2.54-.2-5.37-.51-7.94l16.6,2a40.77,40.77,0,0,0-.38,10.05,6.13,6.13,0,0,0,.23,1c0,.05,0,.11,0,.18C250.22,135.8,248.77,140.94,246.56,141.85Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61,133.66c0,.05,0,.11,0,.18-10.62,2-14.75-9.36-15.83-13.19l15.94,1.92a41.08,41.08,0,0,0-.39,10.05A7.24,7.24,0,0,0,249.61,133.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.21,97.81c-1.77,5.75,1.24,22.39,5.32,26.11,5.93,5.39,15.65,5.92,20.23-1.2,4.44-6.91.14-28.53-4.42-31.91C242.61,85.84,230.82,89.31,228.21,97.81Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.36,108.12c0-.05-.08.06-.07.11.23,1.12.31,2.43-.64,3,0,0,0,.08,0,.06C242.88,110.88,242.76,109.14,242.36,108.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.15,107.12c-1.83.18-1.33,3.82.36,3.66S242.68,107,241.15,107.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.92,107.41s.09,0,.1.09c.11,1.14.44,2.41,1.51,2.65,0,0,0,.06,0,.06C249.26,110.21,248.85,108.51,248.92,107.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.76,106.1c1.8-.38,2.44,3.24.77,3.59S248.26,106.42,249.76,106.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.49,105.65a13,13,0,0,0,1.34-.69,2.47,2.47,0,0,0,1.24-1,.79.79,0,0,0-.25-.92,1.92,1.92,0,0,0-1.95.07,2.83,2.83,0,0,0-1.46,1.43A.83.83,0,0,0,239.49,105.65Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92,104.07a12.62,12.62,0,0,1-1.49-.18,2.41,2.41,0,0,1-1.5-.47.78.78,0,0,1-.08-1,1.94,1.94,0,0,1,1.85-.61,2.77,2.77,0,0,1,1.86.84A.82.82,0,0,1,250.92,104.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.74,118.73c.3.23.62.56,1,.54a3.14,3.14,0,0,0,1.18-.45,0,0,0,0,1,.06.05,1.53,1.53,0,0,1-1.35.8,1.21,1.21,0,0,1-1-.87C242.61,118.73,242.69,118.7,242.74,118.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.46,115.19a3.84,3.84,0,0,0,2.8,1.36,5,5,0,0,0,1.39-.12,1.11,1.11,0,0,0,.26-.07l.24-.07a.29.29,0,0,0,.2-.28h0a.43.43,0,0,0,0-.11h0l0-.1c-.09-.87-.36-2.18-.36-2.18.34.11,2.06.62,2,.17a58.67,58.67,0,0,0-3.06-11.43.11.11,0,0,0-.21.06c.57,3.61,1.76,7.1,2.39,10.72a6.77,6.77,0,0,0-1.89-.31c-.12,0,.55,2.52.56,2.92v0a5.37,5.37,0,0,1-4.14-.69C243.46,115,243.38,115.11,243.46,115.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.08,116.06a4.63,4.63,0,0,1-1.63,1.66,2.17,2.17,0,0,1-1.24.25c-.93-.12-1.07-.94-1-1.67a5.21,5.21,0,0,1,.26-1.14A6,6,0,0,0,247.08,116.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,117.72a2.17,2.17,0,0,1-1.24.25c-.93-.12-1.07-.94-1-1.67A2.14,2.14,0,0,1,245.45,117.72Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,112.94c3.32-.54,4.7-5.54,4.76-9.2,0-2.71-1-8.14,1.67-10s5.7.1,8.94-.5c1.37-.26,2.57-1.75,4.05-1.75,2.39,0,4.79,6.44,4.79,6.44s-.78-9-9.34-9.7c-8.25-.65-14.2,2.33-15.86,8.33C225.82,104.32,229,112.94,229,112.94Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74,111.37s-3.86-5.31-6.28-3.92.56,9.13,3.44,10.14a2.91,2.91,0,0,0,3.87-1.64Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.37,109.65c-.05,0-.05.06,0,.07,2,.78,3.11,2.62,3.89,4.54a1.62,1.62,0,0,0-2.42-.4c-.05,0,0,.12.06.11a1.79,1.79,0,0,1,2,.59,8.81,8.81,0,0,1,1,1.58c.1.18.42.08.35-.13l0-.05C231.18,113.4,229.12,109.85,226.37,109.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.3,132.08l-3.8,9.59-11.95-12.06-3.36,3.9s11.73,19.19,11.8,18.32l3.9-8.27,5.73,5.72-.53-14.41Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.76,142.14c-.17-2.37-.27-4.77-.55-7.14,0-.08-.14-.12-.16,0-.46,2.3.22,11.38.22,13.56l0,0c-.24-.25-5.31-5-5.36-5-.84,1.32-3.71,7.34-3.91,7.89-1.85-3-9.72-15.07-11.91-17.95-.06-.08-.19,0-.14.08,1.64,3.23,11.8,19.08,11.94,19a90.83,90.83,0,0,0,4.09-8.74c.86,1,6,6.44,6,6.09C252.05,147.58,251.92,144.52,251.76,142.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.54,179.66a178,178,0,0,0-18.86,5l-.27.08c-3.22,1.06-5.23,1.86-5.7,1.91l-.1-.07h0a4.05,4.05,0,0,0-.94-.59c-.87-.38-9.35-1.95-9-4.58s3.83-2.23,4.34-2.17c-.55-.15-5.12-1.51-3.47-3.73,1.16-1.58,5.74-1.07,6.2-1-.46-.18-4.63-1.82-3-4.1,1.15-1.63,6.26-1.1,6.84-1-.47-.21-4.22-1.07-2.33-3,1.31-1.35,10.87.67,15,3.06C232.47,173,237.54,179.66,237.54,179.66Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.68,184.66l-.27.08a31,31,0,0,0-11.21-5.36c-.27,0-.28-.2,0-.17A21.14,21.14,0,0,1,218.68,184.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,174.66c6,1.57,8.67,3.07,13.69,6.7a.07.07,0,0,0,.1-.11c-4.66-3.93-7.58-5.92-13.73-6.74C209.75,174.47,209.69,174.59,210,174.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.76,169.55c5.74,1.89,8.73,3.41,13.2,7.49.11.1.25,0,.15-.14a21.84,21.84,0,0,0-13.28-7.51C213.46,169.32,213.4,169.43,213.76,169.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.87,78.14A20.4,20.4,0,0,1,172.78,91l-10.21,1.5,5.11-8.82a20.41,20.41,0,1,1,39.19-5.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.87,78.14a20.51,20.51,0,0,1-4.12,10.34,20.76,20.76,0,0,1-1.85,2.13,23.24,23.24,0,0,1-2.15,1.82,20.64,20.64,0,0,1-10.42,4,20.54,20.54,0,0,1-2.83.06,17.75,17.75,0,0,1-2.82-.3,20.55,20.55,0,0,1-10.1-5l.24.07-10.2,1.57-.74.11.38-.65,5.08-8.84,0,.35a20.61,20.61,0,1,1,39.56-5.73Zm0,0a20.18,20.18,0,0,0-23.14-22.09,20.27,20.27,0,0,0-8.43,3.33A21.23,21.23,0,0,0,169.2,66a20.06,20.06,0,0,0-2.59,8.64,20.33,20.33,0,0,0,1.44,8.89l.07.18-.1.17-5.14,8.8-.36-.54,10.22-1.43.14,0,.1.1a20.16,20.16,0,0,0,9.77,5,22.21,22.21,0,0,0,5.56.33,20,20,0,0,0,5.45-1.2,18.87,18.87,0,0,0,4.92-2.65,18,18,0,0,0,4-3.91A20.49,20.49,0,0,0,206.87,78.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.14,
    y: 65.04,
    width: 4.82,
    height: 21.92,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.14,
    y: 65.04,
    width: 4.82,
    height: 21.92,
    transform: "translate(110.55 262.54) rotate(-90)",
    style: {
      fill: "#e5c15c"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorsCuate);
export default __webpack_public_path__ + "static/media/doctors-cuate.ed95f99b6de8035d01795955c77463c0.svg";
export { ForwardRef as ReactComponent };